console.log('product-v2 call');
var fitsmartObject1;
//var profileAPIData;
var bscFlag = false;
var korraFlag = false;
var fitSmartProfiles;
if (window.productInfo && $('.template-product').length > 0) {
  var pdpType_low = $('body').attr('data-type');
  function viewUpdateTable(){
   fitsmartObject1 = localStorage.getItem("fitsmartobjNew");
   fitsmartObject1 = JSON.parse(fitsmartObject1);    
    console.log('fitsmartObject1NN',fitsmartObject1);
    
  if(fitsmartObject1 && fitsmartObject1.length){
   
    let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
    let JeansSize = {28: '28', 29: '29', 30: '30', 31: '31', 32: '32', 33: '33', 34: '34', 35: '35', 36: '36', 37: '37', 38: '38', 39: '39', 40: '40', 41: '41', 42: '42'};
    let heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
    let bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'}
    let hipClass = {'flat':'Flat','standard':'Standard','heavy':'Heavy'}
    let silData = {'taper':'Taper','straight':'Straight'}
    
     // Start - Existing user Bodytype and height
    
      var existingUser_bodytype = fitsmartObject1[0]['_Body Type?'];
      var existingUser_height = fitsmartObject1[0]['_Height?'];
      var existingUser_hip = fitsmartObject1[0]['_Hip?'];

      $('.Im-New-Filter .ProductSize__BodyType').hide();
      $('.Im-New-Filter .ProductSize__Height').hide();
      $('.Im-New-Filter .ProductSize__Hip').hide();
      var bodyTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
      var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
      var hipData = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
    
      if(existingUser_bodytype != bodyTypeData){                                 
        $('.edit_profile_module .ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();
        $('.Im-New-Filter .ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();                                         
      }

      if(existingUser_height != heightData){
        $('.edit_profile_module .ProductSize__Height [value="'+ existingUser_height +'"]').click();
        $('.Im-New-Filter .ProductSize__Height [value="'+ existingUser_height +'"]').click();                                    
      }
    
      // if(existingUser_hip != hipData){
      //    $('.edit_profile_module .ProductSize__Hip [value="'+ existingUser_hip +'"]').click();
      //    $('.Im-New-Filter .ProductSize__Hip [value="'+ existingUser_hip +'"]').click();                                    
      //  }
    
       $('.size-pop-profile.existing_user').removeClass('hide');
       $('.existing_user .profile_bodytype').html(bodyTypeName[existingUser_bodytype]);
       $('.existing_user .profile_height').html(heightTable[existingUser_height]);
       // $('.existing_user .profile_hip').html(hipClass[existingUser_hip]);
    
     // End - Existing user Bodytype and height

    var editLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
      return (n.category == pdpType_low);
    });
    
  console.log('editLineBSC',editLineBSC);

    if(editLineBSC.length > 0){
      
         var st_bType = editLineBSC[0]['_Body Type?'];
         var st_height = editLineBSC[0]['_Height?'];
         var st_hip = editLineBSC[0]['_Hip?'];
      
        $('.profile_bodytype').html(bodyTypeName[st_bType]);
        $('.profile_height').html(heightTable[st_height]);
        // $('.profile_hip').html(hipClass[st_hip]);
      if(editLineBSC[0].category == 'shirt'){
         var st_size = editLineBSC[0]['_Shirt Size?'];
         var st_shType = editLineBSC[0]['_Shoulder Type?'];
         var st_fit = editLineBSC[0]['_Preferred Fit?'];
         if(typeof st_size === 'undefined' || st_size === null ){
            $('.data_drawer_two').addClass('hide');
            $('.data_drawer_one').removeClass('hide');
          $('.contBtnDrawer').hide();
        }else{
        $('.profile_size').html(sizeTable[st_size]);
        $('.profile_st').html(st_shType);
        $('.profile_fit').html(st_fit);

        $('.contBtnDrawer').show();
        $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
        }
      }else{
        var st_semisize = editLineBSC[0]['_Size?']; 
        var st_silhouette = editLineBSC[0]['_Silhouette?'];
        var st_fit = editLineBSC[0]['_Preferred Fit?'];
        var changefitText = {'Standard':'Structured', 'Slim':'Slim', 'Store_Fit':'Store_Fit'};
        console.log('st_korrasizelocal',st_semisize);
        console.log('st_fit__',changefitText[st_fit]);
        if(typeof st_semisize === 'undefined' || st_semisize === null ){
            $('.data_drawer_two').addClass('hide');
            $('.data_drawer_one').removeClass('hide');
          $('.contBtnDrawer').hide();
        }else{
         $('.profile_size_semi').html(st_semisize);
        if(editLineBSC[0].category == 'jackets'){
          $('.profile_sil_semi').html(changefitText[st_fit]);
        }else{
         $('.profile_sil_semi').html(st_silhouette); 
        } 
          
          $('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+st_semisize+'"]').click();
          $('input[type="hidden"][name="properties[_Size?]"]').val(st_semisize);    
          if($('.edit_data_module .edit_size_module [value="'+st_semisize+'"]').hasClass('activeradio') == false)
          {
            $('.edit_data_module .edit_size_module [value="'+st_semisize+'"]').click();
          }  
          
          $('.contBtnDrawer').show();
          $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
          
           if($('#Filter_As_Modal .ProductForm__SizeContent li [data-tag="one"]').hasClass('active'))
           {
             $('.contBtnDrawer').show();
             $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
           }
           if($('#Filter_As_Modal .ProductForm__SizeContent li [data-tag="two"]').hasClass('active'))
           {
             $('.contBtnDrawer').hide();
             $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
           }
        }
      }                      
    }else{
      
    var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
    var progressData2 = activeElem2/totalElem2*100;

    $('.fit_progressbar span').css('width',progressData2+'%');
    $('.selFit').html(activeElem2);
    $('.totFit').html(totalElem2);
          if(activeElem2 == totalElem2){
        $('.calculateSize').removeClass('disCalculatebtn');
    }else{
        $('.calculateSize').addClass('disCalculatebtn');
    }
      $('.sel_size').removeClass('hide');
      $('.fitsmart-button').addClass('hide');
      $('.product-handle-button').addClass('hide'); 
      console.log('hi in wrong data');
      setTimeout(function(){
         $('.data_drawer_two').addClass('hide');
         $('.data_drawer_one').removeClass('hide');
      },1000)

      $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__ShoulderType [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__PreferredFit [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__ShoulderType').removeClass('active');
      $('.ProductSize__PreferredFit').removeClass('active');
      $('.ProductSize__ShirtSize').removeClass('active');
    }

  } else{
$('.sel_size').removeClass('hide');
    console.log('removbe10')
    setTimeout(function(){
          $('.data_drawer_two').addClass('hide');
      $('.data_drawer_one').removeClass('hide');  
    },1000)
      $('.fitsmart-button').addClass('hide');
      $('.product-handle-button').addClass('hide'); 
      $('.size-pop-profile.existing_user').addClass('hide');

    var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
    var progressData2 = activeElem2/totalElem2*100;

    $('.fit_progressbar span').css('width',progressData2+'%');
    $('.selFit').html(activeElem2);
    $('.totFit').html(totalElem2);
          if(activeElem2 == totalElem2){
        $('.calculateSize').removeClass('disCalculatebtn');
    }else{
        $('.calculateSize').addClass('disCalculatebtn');
    }
      $('.Im-New-Filter .ProductSize__BodyType').show();
      $('.Im-New-Filter .ProductSize__Height').show();
      // $('.Im-New-Filter .ProductSize__Hip').show();
   console.log('no any profile in guest user')

          $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__ShoulderType [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__PreferredFit [type="radio"]').prop('checked',false).removeClass('activeradio');
      $('.ProductSize__ShoulderType').removeClass('active');
      $('.ProductSize__PreferredFit').removeClass('active');
      $('.ProductSize__ShirtSize').removeClass('active');
      $('.ProductSize__BodyType').removeClass('active');
      // $('.ProductSize__Hip').removeClass('active');
      $('.Im-New-Filter .ProductSize__ShirtSize').find(".Property__Field").removeClass('hide');
      $('.Im-New-Filter .ProductSize__BodyType [type="radio"]').prop('checked',false).removeClass('activeradio');
      // $('.Im-New-Filter .ProductSize__Hip [type="radio"]').prop('checked',false).removeClass('activeradio');
  
  }  
}
  function loginViewUpdateTable(){
    window.profileAPIData = localStorage.getItem("getprofile");
    profileAPIData = JSON.parse(profileAPIData);
    console.log('hi profile',profileAPIData)
    if(profileAPIData){
      console.log('in login view table',profileAPIData)
     fitSmartProfiles = profileAPIData.fitProfiles;
    var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length; 
    var progressData2 = activeElem2/totalElem2*100;

    $('.fit_progressbar span').css('width',progressData2+'%');
    $('.selFit').html(activeElem2);
    $('.totFit').html(totalElem2);
    if(activeElem2 == totalElem2){
    $('.calculateSize').removeClass('disCalculatebtn');
    }else{
    $('.calculateSize').addClass('disCalculatebtn');
    }
    //window.GetCustomerAct(fitsmartCustomerId,true);
    
    console.log('login in table',fitSmartProfiles)
    if(fitSmartProfiles.length){
      console.log('exist profile');
      var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
        return (n.categoryName == pdpTypeLow) ;
      });
     console.log('profileData11==',profileData);
      let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      let JeansSize = {28: '28', 29: '29', 30: '30', 31: '31', 32: '32', 33: '33', 34: '34', 35: '35', 36: '36', 37: '37', 38: '38', 39: '39', 40: '40', 41: '41', 42: '42'};
      let heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
      let bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'}
      
       // Start - Existing user Bodytype and height
      
        var existingUser_bodytype = profileAPIData.profileFitsmart.bodyShape;
        var existingUser_height = profileAPIData.profileFitsmart.height;
        var existingUser_hip = profileAPIData.profileFitsmart.hipClass;
  
        console.log('existingUser_bodytype',existingUser_bodytype);
        console.log('existingUser_height',existingUser_height);
        console.log('existingUser_hip',existingUser_hip);
         if(typeof existingUser_hip === 'undefined' ){
               console.log('hip miss')
            $('.Im-New-Filter .ProductSize__BodyType').hide()
            $('.Im-New-Filter .ProductSize__Height').hide()
            var bodyTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
            var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();

            console.log('bodyTypeData',bodyTypeData);
            console.log('heightData',heightData);
          
            if(existingUser_bodytype != bodyTypeData){
              console.log('ProductSize__BodyType')
              $('.ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();
            }
      
            if(existingUser_height != heightData){
              $('.ProductSize__Height [value="'+ existingUser_height +'"]').click();
            }
             // $('span.profile_hip').closest('li').addClass('hide');
             $('.size-pop-profile.existing_user').removeClass('hide');
             $('.existing_user .profile_bodytype').html( bodyTypeName[existingUser_bodytype]);
             $('.existing_user .profile_height').html(heightTable[existingUser_height]);
          
         }else{
        $('.Im-New-Filter .ProductSize__BodyType').hide()
        $('.Im-New-Filter .ProductSize__Height').hide()
        // $('.Im-New-Filter .ProductSize__Hip').hide()
        var bodyTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
        var hipData = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
        console.log('bodyTypeData',bodyTypeData);
        console.log('heightData',heightData);
        console.log('hipData',hipData);
        $('span.profile_hip').closest('li').removeClass('hide');
        if(existingUser_bodytype != bodyTypeData){
          console.log('ProductSize__BodyType')
          $('.ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();
        }
  
        if(existingUser_height != heightData){
          $('.ProductSize__Height [value="'+ existingUser_height +'"]').click();
        }
  
        // if(existingUser_hip != hipData){
        //   $('.ProductSize__Hip [value="'+ existingUser_hip +'"]').click();
        // }
        
         $('.size-pop-profile.existing_user').removeClass('hide');
         $('.existing_user .profile_bodytype').html( bodyTypeName[existingUser_bodytype]);
         $('.existing_user .profile_height').html(heightTable[existingUser_height]);
         // $('.existing_user .profile_hip').html(existingUser_hip);
      
         }

       // End - Existing user Bodytype and height
  
      if(profileData.length > 0){ 
        var recommendedSize;
        var updateOn = profileData[0].updatedOn;
        var updateBy = profileData[0].updatedBy;

        let unix_timestamp = updateOn
        var date = new Date(unix_timestamp * 1000);
        var monthName = date.toLocaleString("default", { month: "long" });
        var day = date.getUTCDate();
        var month = date.getUTCMonth() + 1;
        var year = date.getUTCFullYear();
        if(day < 10){
          day = '0'+day
        }
        if(month < 10){
          month = '0'+month
        }
              var exFormate1;
             if(day == 01){
               exFormate1 = 'st '
             }else if(day == 02){
               exFormate1 = 'nd '
             }else if(day == 03){
               exFormate1 = 'rd '
             }else{
               exFormate1 = 'th '
             }
        var formattedLongtime = day + exFormate1 + monthName +" "+ year;
        
        setTimeout(function(){
          console.log("formattedLongtime_1",formattedLongtime);
          $('.timeAndStore').html(updateBy + '<br> Updated Your size on '+formattedLongtime );
        },500) 
        
       if(profileData.length > 0 && profileData[0].fitsmart.stdSize.isRecommended == true){ 
          console.log('remove3')
          recommendedSize = profileData[0].fitsmart.stdSize.value;
         console.log('recommendedSize',recommendedSize);
            $('.recommended_sizeblock .recommended_size').text(recommendedSize);
            $('.recommended_sizeblock').show();
            $('.data_drawer_two').addClass('hide');
            $('.data_drawer_one').removeClass('hide');
            $('.hidden-phone.sel_size').removeClass('hide');
            $('.hidden-tablet-and-up.sel_size').removeClass('hide');
            $('.fitsmart-button').addClass('hide');
            $('.product-handle-button').addClass('hide');    
  
            $('.contBtnDrawer').hide();
            $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
          
          }else{
           // $('span.profile_hip').closest('li').removeClass('hide');
          $('.hidden-tablet-and-up.sel_size').addClass('hide');
          $('.hidden-phone.sel_size').addClass('hide');
          $('.product-handle-button').removeClass('hide');
          $('.fitsmart-button').removeClass('hide');
            $('.data_drawer_one').addClass('hide');
            $('.data_drawer_two').removeClass('hide');
           var st_bType = profileAPIData.profileFitsmart.bodyShape;
           var st_height = profileAPIData.profileFitsmart.height;
           var st_hip = profileAPIData.profileFitsmart.hipClass;
           $('.profile_bodytype').html(bodyTypeName[st_bType]);
           $('.profile_height').html(heightTable[st_height]);
           // $('.profile_hip').html(st_hip);
  

        if(profileData[0].category == 'Shirts'){
           var st_size = profileData[0].fitsmart.stdSize.value;
           var st_shType = profileData[0].fitsmart.shoulderType.value;
           var st_fit = profileData[0].fitsmart.fit.value;
          
          $('.profile_size').html(sizeTable[st_size]);
          $('.profile_st').html(st_shType);
          $('.profile_fit').html(st_fit);
  
          //recommendedSize = st_size;
          //recommendedSize = sizeTable[st_size];
          //console.log('recommendedSize',recommendedSize);
  
           $('.contBtnDrawer').show();
           $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
          var sizeData = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
          var shData = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
          var fitData = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
          console.log('fitData',fitData)
          // console.log('sizeData',sizeData);console.log('shData',shData);console.log('fitData',fitData);
          
          if(shData != st_shType){
            document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${st_shType}"]`).click();
          }
          if(sizeData != st_size){
            document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${st_size}"]`).click();
          }
          if(fitData != st_fit){
            document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${st_fit}"]`).click();
          }
        }
        else{
             var st_semisize = profileData[0].fitsmart.stdSize.value;
             var semisizeData = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
             var udata = st_semisize.toUpperCase();
            console.log('udata',udata)
            console.log('semisizeData',semisizeData)
               $('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+st_semisize.toUpperCase()+'"]').click();
               $('input[type="hidden"][name="properties[_Size?]"]').val(st_semisize.toUpperCase());
               $('.profile_size_semi').html(st_semisize.toUpperCase());
              
               $('.contBtnDrawer').show();
               $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
               //recommendedSize = st_semisize.toUpperCase();
          
                if(st_semisize >= 40){
                   $('.ProductSize__Elements.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.Property__Field').addClass('hide');
                }else{
                  $('.ProductSize__Elements.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.Property__Field').removeClass('hide');
                }
                if(semisizeData != udata){
                   console.log('click data')
                    document.querySelector(`.edit_size_module input[name="properties[_Size?]"][value="${st_semisize.toUpperCase()}"]`).click();
                 }
          
               if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                  var silhouette = "NA";
                }
                else if(pdpType_low == 'jackets'){
                var jk_fit = profileData[0].fitsmart.fit.value;
                var changefitText = {'Standard':'Structured', 'Slim':'Slim', 'Store_Fit':'Store_Fit'};
                var _Preferred_fit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
                  console.log("jk_fit",jk_fit);
                  console.log("_Preferred_fit 1",_Preferred_fit);
                 if(jk_fit != _Preferred_fit){ 
                   // var backUPfit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
                   //  console.log('edit data prefereed_fit',backUPfit);
                   //   if(typeof backUPfit === 'undefined' ){
                   //   }else{
                   //  document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${jk_fit}"]`).click();
                   // }
                   document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${jk_fit}"]`).click();
                  }
                  $('.profile_sil_semi').html(changefitText[jk_fit]);
                }
                else {
                  var st_silhouette = profileData[0].fitsmart.silhouette.value;
                  $('.profile_sil_semi').html(st_silhouette);
                  var silhouette = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
                   if(silhouette != st_silhouette){ 
                    console.log('edit data condition true')
                    document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${st_silhouette}"]`).click();
                  }
                }
        }  
          }
          
           
          }
      else{
            $('.hidden-tablet-and-up.sel_size').removeClass('hide');
            $('.hidden-phone.sel_size').removeClass('hide');
            $('.product-handle-button').addClass('hide');
            $('.fitsmart-button').addClass('hide');

            //apview change
            $('.data_drawer_one').removeClass('hide');
            $('.data_drawer_two').addClass('hide');
          }
      }
    else{ 
        setTimeout(function(){
        var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
        var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
        var progressData2 = activeElem2/totalElem2*100;
  
      $('.fit_progressbar span').css('width',progressData2+'%');
      $('.selFit').html(activeElem2);
      $('.totFit').html(totalElem2);
       
       if(activeElem2 == totalElem2){
          $('.calculateSize').removeClass('disCalculatebtn');
      }else{
          $('.calculateSize').addClass('disCalculatebtn');
      }
           },200)
        $('.sel_size').removeClass('hide');
        console.log('hi in wrong data');
        $('.data_drawer_two').addClass('hide');
        console.log('remove5')
        $('.data_drawer_one').removeClass('hide');
        $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__ShoulderType [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__PreferredFit [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__ShoulderType').removeClass('active');
        $('.ProductSize__PreferredFit').removeClass('active');
        $('.ProductSize__ShirtSize').removeClass('active');
      }
    }else{
        $('.data_drawer_two').addClass('hide');
        $('.data_drawer_one').removeClass('hide');
        $('.size-pop-profile.existing_user').addClass('hide');
        window.GetCustomerAct(fitsmartCustomerId,true);
    }
}
  function loginViewUpdateTable1(profileAPIData){
    console.log('in login view table',profileAPIData)
     //fitSmartProfiles = profileAPIData.fitProfiles;
    var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length; 
    var progressData2 = activeElem2/totalElem2*100;
    
    $('.fit_progressbar span').css('width',progressData2+'%');
    $('.selFit').html(activeElem2);
    $('.totFit').html(totalElem2);
    if(activeElem2 == totalElem2){
    $('.calculateSize').removeClass('disCalculatebtn');
    }else{
    $('.calculateSize').addClass('disCalculatebtn');
    }
    //window.GetCustomerAct(fitsmartCustomerId,true);
    
    console.log('login in table',fitSmartProfiles)
    if(fitSmartProfiles.length){
      console.log('exist profile');
      var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
        return (n.categoryName == pdpTypeLow) ;
      });
     console.log('profileData11==',profileData);
      let sizeTable = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      let JeansSize = {28: '28', 29: '29', 30: '30', 31: '31', 32: '32', 33: '33', 34: '34', 35: '35', 36: '36', 37: '37', 38: '38', 39: '39', 40: '40', 41: '41', 42: '42'};
      let heightTable = {152: "5'0", 155: "5'1", 157: "5'2", 160: "5'3", 163: "5'4", 165: "5'5", 168: "5'6", 170: "5'7", 173: "5'8", 175: "5'9", 178: "5'10", 180: "5'11", 183: "6'0", 185: "6'1", 188: "6'2", 191: "6'3", 193: "6'4", 196: "6'5", 198: "6'6"};
      let bodyTypeName = {'athletic':'Athletic','average':'Slight belly','healthy':'Significant Belly'}
      
       // Start - Existing user Bodytype and height
      
        var existingUser_bodytype = profileAPIData.profileFitsmart.bodyShape;
        var existingUser_height = profileAPIData.profileFitsmart.height;
        var existingUser_hip = profileAPIData.profileFitsmart.hipClass;
  
        console.log('existingUser_bodytype',existingUser_bodytype);
        console.log('existingUser_height',existingUser_height);
        console.log('existingUser_hip',existingUser_hip);
        
           if(typeof existingUser_hip === 'undefined' ){
               console.log('hip miss1')
             setTimeout(function(){
               $('span.profile_hip').closest('li').addClass('hide');
             },500)
             
            $('.Im-New-Filter .ProductSize__BodyType').hide()
            $('.Im-New-Filter .ProductSize__Height').hide()
            var bodyTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
            var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();

            console.log('bodyTypeData',bodyTypeData);
            console.log('heightData',heightData);
          
            if(existingUser_bodytype != bodyTypeData){
              console.log('ProductSize__BodyType')
              $('.ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();
            }
      
            if(existingUser_height != heightData){
              $('.ProductSize__Height [value="'+ existingUser_height +'"]').click();
            }
             $('.size-pop-profile.existing_user').removeClass('hide');
             $('.existing_user .profile_bodytype').html( bodyTypeName[existingUser_bodytype]);
             $('.existing_user .profile_height').html(heightTable[existingUser_height]);
          
         }else{
        $('.Im-New-Filter .ProductSize__BodyType').hide()
        $('.Im-New-Filter .ProductSize__Height').hide()
        $('.Im-New-Filter .ProductSize__Hip').hide()
        var bodyTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
        var hipData = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
        console.log('bodyTypeData',bodyTypeData);
        console.log('heightData',heightData);
        console.log('hipData',hipData);
        // $('span.profile_hip').closest('li').removeClass('hide');
        if(existingUser_bodytype != bodyTypeData){
          console.log('ProductSize__BodyType')
          $('.ProductSize__BodyType [value="'+ existingUser_bodytype +'"]').click();
        }
  
        if(existingUser_height != heightData){
          $('.ProductSize__Height [value="'+ existingUser_height +'"]').click();
        }
  
        // if(existingUser_hip != hipData){
        //   $('.ProductSize__Hip [value="'+ existingUser_hip +'"]').click();
        // }
        
         $('.size-pop-profile.existing_user').removeClass('hide');
         $('.existing_user .profile_bodytype').html( bodyTypeName[existingUser_bodytype]);
         $('.existing_user .profile_height').html(heightTable[existingUser_height]);
         // $('.existing_user .profile_hip').html(existingUser_hip);
      
         }
       // End - Existing user Bodytype and height
  
      if(profileData.length > 0){ 
        var recommendedSize;
        var updateOn = profileData[0].updatedOn;
        var updateBy = profileData[0].updatedBy;

        let unix_timestamp = updateOn
        var date = new Date(unix_timestamp * 1000);
        var monthName = date.toLocaleString("default", { month: "long" });
        var day = date.getUTCDate();
        var month = date.getUTCMonth() + 1;
        var year = date.getUTCFullYear();
        if(day < 10){
          day = '0'+day
        }
        if(month < 10){
          month = '0'+month
        }
              var exFormate1;
             if(day == 01){
               exFormate1 = 'st '
             }else if(day == 02){
               exFormate1 = 'nd '
             }else if(day == 03){
               exFormate1 = 'rd '
             }else{
               exFormate1 = 'th '
             }
        var formattedLongtime = day + exFormate1 + monthName +" "+ year;
        
        setTimeout(function(){
          console.log("formattedLongtime_2",formattedLongtime);
          $('.timeAndStore').html(updateBy + '<br> Updated Your size on '+formattedLongtime );
        },500) 
        
       if(profileData.length > 0 && profileData[0].fitsmart.stdSize.isRecommended == true){ 
          console.log('remove3')
          recommendedSize = profileData[0].fitsmart.stdSize.value;
            $('.recommended_sizeblock .recommended_size').text(recommendedSize);
            $('.recommended_sizeblock').show();
            $('.data_drawer_two').addClass('hide');
            $('.data_drawer_one').removeClass('hide');
            $('.hidden-phone.sel_size').removeClass('hide');
            $('.hidden-tablet-and-up.sel_size').removeClass('hide');
            $('.fitsmart-button').addClass('hide');
            $('.product-handle-button').addClass('hide');    
  
            $('.contBtnDrawer').hide();
            $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
          
          }else{
         
           $('.hidden-tablet-and-up.sel_size').addClass('hide');
          $('.hidden-phone.sel_size').addClass('hide');
          $('.product-handle-button').removeClass('hide');
          $('.fitsmart-button').removeClass('hide');
            $('.data_drawer_one').addClass('hide');
            $('.data_drawer_two').removeClass('hide');
           var st_bType = profileAPIData.profileFitsmart.bodyShape;
           var st_height = profileAPIData.profileFitsmart.height;
           var st_hip = profileAPIData.profileFitsmart.hipClass;
           $('.profile_bodytype').html(bodyTypeName[st_bType]);
           $('.profile_height').html(heightTable[st_height]);
           // $('.profile_hip').html(st_hip);
        if(profileData[0].category == 'Shirts'){
           var st_size = profileData[0].fitsmart.stdSize.value;
           var st_shType = profileData[0].fitsmart.shoulderType.value;
           var st_fit = profileData[0].fitsmart.fit.value;
          
          $('.profile_size').html(sizeTable[st_size]);
          $('.profile_st').html(st_shType);
          $('.profile_fit').html(st_fit);
  
          //recommendedSize = st_size;
          // recommendedSize = sizeTable[st_size];
          // console.log('recommendedSize',recommendedSize);
  
           $('.contBtnDrawer').show();
           $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
          var sizeData = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
          var shData = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
          var fitData = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
          console.log('fitData',fitData)
          // console.log('sizeData',sizeData);console.log('shData',shData);console.log('fitData',fitData);
          
          if(shData != st_shType){
            document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${st_shType}"]`).click();
          }
          if(sizeData != st_size){
            document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${st_size}"]`).click();
          }
          if(fitData != st_fit){
            document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${st_fit}"]`).click();
          }
        }
        else{
              var st_semisize = profileData[0].fitsmart.stdSize.value;
             
               $('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+st_semisize.toUpperCase()+'"]').click();
               $('input[type="hidden"][name="properties[_Size?]"]').val(st_semisize.toUpperCase());
               $('.profile_size_semi').html(st_semisize.toUpperCase());
              
               $('.contBtnDrawer').show();
               $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
               // recommendedSize = st_semisize.toUpperCase();
               if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                  var silhouette = "NA";
                }
               else if(pdpType_low == 'jackets'){
                var jk_fit = profileData[0].fitsmart.fit.value;
               var changefitText = {'Standard':'Structured', 'Slim':'Slim', 'Store_Fit':'Store_Fit'};
                var _Preferred_fit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
                  console.log("jk_fit",jk_fit);
                  console.log("_Preferred_fit 2",_Preferred_fit);
                 if(jk_fit != _Preferred_fit){ 
                   // var backUPfit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
                   //  console.log('edit data prefereed_fit',backUPfit);
                   //   if(typeof backUPfit === 'undefined' ){
                   //   }else{
                   //  document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${jk_fit}"]`).click();
                   // }
                   document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${jk_fit}"]`).click();
                  }
                 $('.profile_sil_semi').html(changefitText[jk_fit]);
                }
                else {
                  var st_silhouette = profileData[0].fitsmart.silhouette.value;
                  $('.profile_sil_semi').html(st_silhouette);
                  var silhouette = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
                   if(silhouette != st_silhouette){ 
                    console.log('edit data condition true')
                    document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${st_silhouette}"]`).click();
                  }
                }
        }
          }
            
          }
      else{
            $('.hidden-tablet-and-up.sel_size').removeClass('hide');
            $('.hidden-phone.sel_size').removeClass('hide');
            $('.product-handle-button').addClass('hide');
            $('.fitsmart-button').addClass('hide');

            //apview change
            $('.data_drawer_one').removeClass('hide');
            $('.data_drawer_two').addClass('hide');
          }
      }
    else{ 
        setTimeout(function(){
        var activeElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
        var totalElem2 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
        var progressData2 = activeElem2/totalElem2*100;
  
      $('.fit_progressbar span').css('width',progressData2+'%');
      $('.selFit').html(activeElem2);
      $('.totFit').html(totalElem2);
       
       if(activeElem2 == totalElem2){
          $('.calculateSize').removeClass('disCalculatebtn');
      }else{
          $('.calculateSize').addClass('disCalculatebtn');
      }
           },200)
        $('.sel_size').removeClass('hide');
        console.log('hi in wrong data');
        $('.data_drawer_two').addClass('hide');
        console.log('remove5')
        $('.data_drawer_one').removeClass('hide');
        $('.data_drawer_one').find('.your-size-popup').addClass('hide');
        $('.Im-New-Filter .ProductSize__BodyType').show()
        $('.Im-New-Filter .ProductSize__Height').show()
        // $('.Im-New-Filter .ProductSize__Hip').show()
        $('.ProductSize__BodyType [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__Height [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__ShoulderType [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__PreferredFit [type="radio"]').prop('checked',false).removeClass('activeradio');
        $('.ProductSize__ShoulderType').removeClass('active');
        $('.ProductSize__PreferredFit').removeClass('active');
        $('.ProductSize__ShirtSize').removeClass('active');

        //up code
        if(profileAPIData.profileFitsmart.bodyShape != null){
          $(`.ProductSize__BodyType`).addClass("active");
          $(`.ProductSize__BodyType [type="radio"][value="${profileAPIData.profileFitsmart.bodyShape}"]`).prop('checked',true).addClass('activeradio');
        }
        if(profileAPIData.profileFitsmart.height != null){
          $(`.ProductSize__Height`).addClass("active");
          $(`.ProductSize__Height [type="radio"][value="${profileAPIData.profileFitsmart.height}"]`).prop('checked',true).addClass('activeradio');
        }
      }
    
}
  function setLocalStoreData(bodyType,hipClass,height,shirtSize,shoulderType,preferredFit,subSize,silhouetteData,pdpType_low){
     fitsmartObject = localStorage.getItem("fitsmartobjNew");
    if(typeof fitsmartObject === 'undefined' || fitsmartObject === null ){
      fitsmartObject = [];
    } else {
      fitsmartObject = JSON.parse(fitsmartObject);
    }

    // Start - Update value of profile data in localstorage
     jQuery.each(fitsmartObject, function(index, item) {
       fitsmartObject[index]['_Body Type?'] = bodyType;
       fitsmartObject[index]['_Height?'] = height;
       fitsmartObject[index]['_Hip?'] = hipClass;
     });

    console.log("fitsmartObject", fitsmartObject);

    var JacketGetLocalData = jQuery.grep(fitsmartObject, function( n, i ) {
      return (n.category != pdpType_low);
    });
    
    var getLocalData = jQuery.grep(fitsmartObject, function( n, i ) {
      return (n.category == pdpType_low);
    });
   console.log('getLocalData',getLocalData)
   console.log('JacketGetLocalData',JacketGetLocalData)
    
    if(getLocalData.length > 0){
    if(getLocalData[0].category == 'shirt'){
    let sizeTableN = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
    var st_sizeN = getLocalData[0]['_Shirt Size?'];
    var newSize = sizeTableN[st_sizeN];
    console.log('newSize',newSize);
     var dataN = $.grep(fitsmartObject, function(e){ 
      return e.category != 'shirt'; 
     });
    }
    if(getLocalData[0].category == 'jackets'){
      var jk_sizeN = getLocalData[0]['_Size?'];
      console.log("jk_sizeN",jk_sizeN);
       var jacketsdataN = $.grep(fitsmartObject, function(e){ 
        return e.category != 'jackets'; 
       });
    }
   }
  
   if($('.template-bsc').length > 0){
      var obj = {"category": "shirt","_Body Type?": bodyType,"_Shirt Size?": shirtSize,"_Shoulder Type?":shoulderType,"_Height?" : height,"_Preferred Fit?":preferredFit,"_Hip?":hipClass,"getsize":shirtSize}
      fitsmartObject.push(obj);
      console.log("obj",obj);
      const key = 'category';
      const arrayUniqueByKey = [...new Map(fitsmartObject.map(item =>[item[key], item])).values()];
      if(bodyType == 'athletic'){
        console.log('atleticorave')
          if(newSize > 44){
            localStorage.setItem("fitsmartobjNew", JSON.stringify(dataN));  
          }else{
            localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
          }
      }else if(bodyType == 'average' ){	
         if(newSize > 48){	
            localStorage.setItem("fitsmartobjNew", JSON.stringify(dataN));	
          }else{	
            localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));	
          }	
      }else if(bodyType == 'healthy' ){
         if(newSize < 40){
            localStorage.setItem("fitsmartobjNew", JSON.stringify(dataN));
          }else{
            localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
          }
      }else{
        localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
      }
          
    }else if($('.template-semi-stitched').length > 0){
      var obj = {"category": pdpType_low,"_Body Type?": bodyType,"_Height?" : height,"_Hip?":hipClass,"_Size?": subSize,"_Preferred Fit?":preferredFit,"_Silhouette?": silhouetteData,"getsize": subSize}
      fitsmartObject.push(obj);
      console.log("obj",obj);
      const key = 'category';
      const arrayUniqueByKey = [...new Map(fitsmartObject.map(item =>[item[key], item])).values()];
      console.log('arrayUniqueByKey',arrayUniqueByKey);
      console.log('jacketsdataN',jacketsdataN);
      console.log('bodyType',bodyType);
      console.log('preferredFit',preferredFit);
      console.log('JacketGetLocalData',JacketGetLocalData);
     console.log("jk_sizeN",jk_sizeN);

      if(bodyType == 'healthy' ){
       if(preferredFit == "Slim" || jk_sizeN < 40 ){
        if(JacketGetLocalData.length == 0){
         localStorage.removeItem("fitsmartobjNew", JSON.stringify(JacketGetLocalData)); 
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Structured"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').removeClass('hide');
         $('.Im-New-Filter .ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').removeClass('hide');
        }else{
         localStorage.setItem("fitsmartobjNew", JSON.stringify(JacketGetLocalData)); 
        }
       }else{
         localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
       }
      }else if(bodyType == 'average'){
        if(jk_sizeN > 48 ){
          if(JacketGetLocalData.length == 0){
            localStorage.removeItem("fitsmartobjNew", JSON.stringify(JacketGetLocalData)); 
          }else{
             localStorage.setItem("fitsmartobjNew", JSON.stringify(JacketGetLocalData)); 
          }
        }else{
          localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
        }
        
      }else{
         localStorage.setItem("fitsmartobjNew", JSON.stringify(arrayUniqueByKey));
      }
    }
      var getnullSize = jQuery.grep(fitsmartObject, function( n, i ) {
      return (typeof n.getsize == 'undefined');
    });
    console.log('fitsmartObject___find',fitsmartObject);
    console.log('getnullSize',getnullSize)

    if(getnullSize.length > 0){
      var updatefit = jQuery.grep(fitsmartObject, function( n, i ) {
        return (n.category != getnullSize[0]['category']);
      });
      // localStorage.removeItem("fitsmartobjNew", JSON.stringify(updatefit));
      if(updatefit.length > 0){
         localStorage.setItem("fitsmartobjNew", JSON.stringify(updatefit));
        console.log("updatefit_no_set",updatefit);
      }else{
        localStorage.removeItem("fitsmartobjNew", JSON.stringify(updatefit));
        console.log("updatefit_yes_remove",updatefit);
      }
    }else{
       console.log('getnullSize___length_no');
    }
    viewUpdateTable();

     // Start -animation stop  
          //$('#animation_only_Scan,.scan_text').hide();
          setTimeout(function(){
            $('.scan-success-loader img').hide();
             var animationBlastTick = document.getElementById("animation_blast_tick");
             console.log('animationBlastTick',animationBlastTick)
             $('#animation_only_Scan,.scan_text').hide();
             $('#animation_blast_tick,.blast_text').show();
             animationBlastTick.play();
          },2000)

        var animationBlastTick = document.getElementById("animation_blast_tick");
        animationBlastTick.addEventListener("loop", (e) => {
          console.log('stop blast tick');
          animationBlastTick.stop();
          $('body').removeClass('showAnimation');
           $('#animation_only_Scan,.scan_text').show();
           $('#animation_blast_tick,.blast_text').hide();
          document.querySelector('.Filter_As_Modal-mobile .get-size-button').click();
        });
    // End -animation stop
 } 

  // Exit_Popup
  $(document).on('click','.Exit_Popup',function(e){
    e.preventDefault();
    if($('.common-btn-edit.added').length > 0){

      $.magnificPopup.open({
        items: {
          src: '#Exit_Popup'
        },
        modal: false,
        type: 'inline',
        callbacks: {
          open: function() {
            $('html').addClass('Popup_Open');
            $('body').addClass('discard_popup');
          },
          close: function(){
            $('html').removeClass('Popup_Open');
            $('body').removeClass('discard_popup');
          }
        }
      });
    } else {
      
      $('.customize-shirt').closest('.ProductMeta__Size').removeClass('hide');
      $('.customise-box').addClass('hide');
    }
    
    $('header').removeClass('no-brands');
    $('body').removeClass('customizationOpen');
    $('.header_brand_icon.hidden-tablet-and-up').removeClass('hide');
    
  });
  
  // exitPopAddtocart
  $(document).on('click', '.exitPopAddtocart', function (e) {
    //$('.customize-shirt').closest('.ProductMeta__Size').removeClass('hide');
    //$('.customise-box').addClass('hide');
    // $('.ProductForm__AddToCart').click();
   if($('body').hasClass('temp_webview')){ 
   }else{
    $('.customize-shirt').closest('.ProductMeta__Size').removeClass('hide');
    $('.customise-box').addClass('hide');
    $('html').removeClass('Popup_Open');
    e.preventDefault();
    $.magnificPopup.close();
    $('.bombay-shirt-item-title').removeClass('hide');
    $('.pro-nex-prev').removeClass('hide');
     }
    if($('body').hasClass('temp_webview')){
      setTimeout(function(){
          $('#shopify-section-header').addClass('hide');
      },100)
      $('html').removeClass('no-scroll');
     var productFormElems = document.querySelector(".ProductForm");
     var newData = $(productFormElems).serializeArray();
      console.log('profileAPIData',profileAPIData);
     const addToCartParams = {"appmakerAction": {"action": "SAVE_CUSTOMISATION","params": {"closeModal":true,"data": newData , "fitsmartData" : profileAPIData }}}
        sendMessageToApp(addToCartParams);

      $.magnificPopup.close();
      CloseModalClick(e);  
     if($('body').hasClass('temp_webview')){ 
        const closeActionParams = {
            "appmakerAction": {
                "action": "CLOSE_MODAL",
                "params": {}
            }
        }
        sendMessageToApp(closeActionParams);
     }
      
    }
    $('.product-handle-button').removeClass('full-btn-atc');
    $('#shopify-section-header').removeClass('hide');
  });
  
  /* Select fits */
  //const PageOverlayElement = document.querySelector('.PageOverlay');
  const buttonElement = document.querySelectorAll(".get-size-button");
  const buttonInfo = document.querySelectorAll(".fitsmart-info");
  const customDrawer = document.querySelector(".ProductForm-Filter");
  const importantNote = document.querySelector('.Important-Note');
  const closeButton = document.querySelector(".ProductForm-Filter .ProductForm__SizeLabel");
  if (buttonElement && buttonElement.length > 0) {
    if (customDrawer) {
      const localObj = localStorage.getItem('fitsmartobj');
      if (localObj) {
        if (importantNote) {
          importantNote.classList.remove('hide');
        }
        const buttonTextElement = document.querySelectorAll(".button-text");
        if (buttonTextElement && buttonTextElement.length > 0) {
          buttonTextElement.forEach(elem => {
            elem.innerText = 'Edit Size';
          })
          /* if localstorage contanins */
          buttonInfo.forEach(elem => {
            elem.innerText = 'Your custom size is saved with us from your last purchase';
          })
        }
      }
  
      /* Handle button click to show drawer on pdp */
      /* start : onscroll add class for size guide left size modal*/
      var mainNav = document.querySelector('body');
      window.onscroll = function () {
        windowScroll();
      };
  
      function windowScroll() {
        mainNav.classList.toggle("popup-scroll-active", mainNav.scrollTop > 50 || document.documentElement.scrollTop > 50);
      }
      /* end : onscroll add class for size guide left size modal*/
      if (window.innerWidth > 767) {
        customDrawer.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small", "mfp-hide", "mobile-margin-bottom")
        if (closeButton) {
          closeButton.addEventListener("click", (event) => {
            document.querySelector('body').classList.remove("popup-active");
            document.querySelector('#shopify-section-header').classList.remove("head-up");
            customDrawer.classList.remove("open");
            //document.querySelector('.whatapp_floating').classList.remove('hide');
            //document.querySelector(".LoggedSizePopupUp img")?.classList.remove('rotate-log-img');
            document.querySelector('.Fitsmart-Size')?.classList.add('hide');
            document.querySelector('.black_bg').classList.remove('active');
            document.querySelector('.Product__Gallery').removeAttribute('style');
            if (!document.querySelector('#BodyType__Guide')?.classList.contains('mfp-hide')) {
              document.querySelector('.BodyType__GuideDismiss')?.click();
            }
            // if (!document.querySelector('#hip__Guide')?.classList.contains('mfp-hide')) {
            //   document.querySelector('.hip__GuideDismiss')?.click();
            // }
            if (!document.querySelector('#PreferredFit__Guide')?.classList.contains('mfp-hide')) {
              document.querySelector('.PreferredFit__GuideDismiss')?.click();
            }
            if (!document.querySelector('#ShoulderType__Guide')?.classList.contains('mfp-hide')) {
              document.querySelector('.ShoulderType__GuideDismiss')?.click();
            }
          })
        }
        buttonElement.forEach(elem => {
          console.log('elem--',elem)
          elem.addEventListener("click", (event) => {
            console.log('elem--12',elem)
           console.log('open..');
            document.querySelector('#shopify-section-header').classList.remove("head-down");
            document.querySelector('#shopify-section-header').classList.add("head-up");
            document.querySelector('body').classList.add("popup-active");
            customDrawer.classList.add("open");
            document.querySelector('.black_bg').classList.add('active');
            document.querySelector('.Product__Gallery').style.zIndex = 0;
            if($('.ProductForm').hasClass('bsc')){
            setTimeout(function(){
            if($('.ProductForm__SavedSize').hasClass('hide')){
              $('.Fitsmart-Size').addClass('hide');
            }else{
              $('.Fitsmart-Size').removeClass('hide');
            }
            },200);
          }
            if (window.innerWidth > 767) {
              $(".ProductForm-Filter").animate({ scrollTop: 0 }, "slow");
            }
            console.log('test',elem.innerText)
            var btnTrimTextDesk = elem.innerText.trim();
           if (btnTrimTextDesk == 'Edit Size') {
             console.log('in view desk')
                  $('.data_drawer_two').removeClass('hide');
                  $('.data_drawer_one').addClass('hide');
              if($('.notlogged').length > 0){
                  viewUpdateTable();
              }else{
                 // window.GetCustomerAct(fitsmartCustomerId,true);
                getCustomerCustom(fitsmartCustomerId,true);
                 //loginViewUpdateTable();
              }
           }else if(btnTrimTextDesk == 'Select size'){
              if($('.logged').length > 0){
                console.log('clicked select size')
             // window.GetCustomerAct(fitsmartCustomerId,true);
                getCustomerCustom(fitsmartCustomerId,true);
              }
           }

          })
        })
      }
      else {

        buttonElement.forEach(elem => {
          elem.addEventListener("click", (event) => {
            var btnTrimText = elem.innerText.trim();
            $.magnificPopup.open({
              items: {
                src: '#Filter_As_Modal'
              },
              type: 'inline',
              preloader: false,
              modal: false,
              mainClass: 'my-mfp-slide-bottom',
              callbacks: {
                beforeOpen: function() {
                  if (btnTrimText == 'Edit Size') {
                    $('.data_drawer_two').removeClass('hide');
                    $('.data_drawer_one').addClass('hide');
                    if($('.notlogged').length > 0){
                        viewUpdateTable();
                    }else{
                      console.log('pgload1')
                      if(!$('body.pageLoaded').length){
                        console.log('pgload')
                       //loginViewUpdateTable();
                        // window.GetCustomerAct(fitsmartCustomerId,true);
                        getCustomerCustom(fitsmartCustomerId,true);
                      }else{
                       console.log('pgload2') 
                      }
                    }
                  }
                },
                open: function () {
                  $('html').addClass('Popup_Open');
                  $('.pro-nex-prev').addClass('hide');
                  console.log('hide data')
                  CustomOpenModalEvent();
                },
                close: function () {
                  $('html').removeClass('Popup_Open');
                  $('.pro-nex-prev').removeClass('hide');
                  CustomCloseModalEvent();
                  if (window.innerWidth < 768) {
                    if (!document.querySelector('#BodyType__Guide')?.classList.contains('mfp-hide')) {
                      document.querySelector('.BodyType__GuideDismiss')?.click();
                    }
                    // if (!document.querySelector('#hip__Guide')?.classList.contains('mfp-hide')) {
                    //   document.querySelector('.hip__GuideDismiss')?.click();
                    // }
                    if (!document.querySelector('#PreferredFit__Guide')?.classList.contains('mfp-hide')) {
                      document.querySelector('.PreferredFit__GuideDismiss')?.click();
                    }
                    if (!document.querySelector('#ShoulderType__Guide')?.classList.contains('mfp-hide')) {
                      document.querySelector('.ShoulderType__GuideDismiss')?.click();
                    }
                    if (!document.querySelector('#ShirtSize__Guide')?.classList.contains('mfp-hide')) {
                      document.querySelector('.ShirtSize__GuideDismiss')?.click();
                    }
                    if (!document.querySelector('#HeightSize__Guide')?.classList.contains('mfp-hide')) {
                      document.querySelector('.HeightSize__GuideDismiss')?.click();
                    }
                  }
                }
              }
            });
          })
        })
      }
    }
  }
  
  
  /* Guide Popup Handle */
  const popup = ['BodyType__Guide', 'hip__Guide', 'ShoulderType__Guide', 'PreferredFit__Guide'];
  const bodyGuide = document.querySelector('#BodyType__Guide')
  if (bodyGuide) {
    bodyGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  const hipGuide = document.querySelector('#hip__Guide')
  if (hipGuide) {
    hipGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  
  const shoulderGuide = document.querySelector('#ShoulderType__Guide')
  if (shoulderGuide) {
    shoulderGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  
  const prefGuide = document.querySelector('#PreferredFit__Guide')
  if (prefGuide) {
    prefGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  
  const ShirtSizeGuide = document.querySelector('#ShirtSize__Guide')
  if (ShirtSizeGuide && window.innerWidth < 768) {
    ShirtSizeGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  
  const HeightSizeGuide = document.querySelector('#HeightSize__Guide')
  if (HeightSizeGuide && window.innerWidth < 768) {
    HeightSizeGuide.classList.remove("animated", "animatedFadeInUp", "fadeInUp", "Popup", "Popup__Small");
  }
  
  /* End of Guide Popup Handle */
  /* End of Select fits */
  
  const filterAsModal = document.querySelector("#Filter_As_Modal .ProductForm__Size");
  const PopupDismiss = document.querySelectorAll('a.Popup__Dismiss');
  let PreferredFitCode = `<div class="content-slide Super-Slim-content"><div class="product-img"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/super-slim.svg" /></div>
                            <div class="product-info"><h3 class="Heading">Super Slim</h3><p>Fitted around the chest,<br> waist and biceps.</p></div>
                            <div class="product-select-button"><a data-value="SuperSlim" class="Button Button--secondary Button--full">Select</a></div>
                          </div>
                          <div class="content-slide"><div class="product-img"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/structured.svg" /></div>
                            <div class="product-info"><h3 class="Heading">Structured</h3><p>Stylishly fitted, but comfortable.</p></div>
                            <div class="product-select-button"><a data-value="Structured" class="Button Button--secondary Button--full">Select</a></div>
                          </div>
                          <div class="content-slide"><div class="product-img"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/relaxed.svg" /></div>
                            <div class="product-info"><h3 class="Heading">Relaxed</h3><p>Loose fitting around the bicep and torso, with enough room for movement.</p></div>
                            <div class="product-select-button"><a data-value="Relaxed" class="Button Button--secondary Button--full">Select</a></div>
                          </div>`;
  
  const buildSlider = (guideType) => {
    if (window.innerWidth < 768) {
      if (guideType == "PreferredFit__GuidePopup" && productInfo.product_vendor == "Bombay Shirt Company") {
        let ProductSizPreferredFit = document.querySelector('.ProductSize__Elements.ProductSize__PreferredFit .Property__Field.hide');
        if (ProductSizPreferredFit) {
          let contentWrapperList = document.querySelector(".PreferredFit__GuidePopup .content-wrapper");
          if (contentWrapperList) {
            contentWrapperList.removeChild(contentWrapperList.querySelector('.Super-Slim-content'));
          }
          $(`.${guideType} .content-tab-title .Super-Slim`).hide();
          $(`.${guideType} .content-tab-title .Structured`).addClass("active");
          $(`.${guideType} .content-tab-title .Structured`).attr("data-count",0);
          $(`.${guideType} .content-tab-title .Relaxed`).attr("data-count",1);
          $(`.${guideType} .content-wrapper`).removeClass('slick-initialized');
        }else{
          $(`.${guideType} .content-tab-title .Super-Slim`).show();
          $(`.${guideType} .content-tab-title .Structured`).attr("data-count",1);
          $(`.${guideType} .content-tab-title .Relaxed`).attr("data-count",2);
          $(`.${guideType} .content-wrapper`).removeClass('slick-initialized');
        }
      }
      $(`.${guideType} .content-wrapper`).not(".slick-initialized").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
      })
      .on("afterChange", function (ev, slick, current, next) {
        $(".content-tab-title .heading").removeClass("active");
        $('.content-tab-title .heading[data-count="' + current + '"]').addClass("active");
      });
      $(`.${guideType} .active`).trigger("click");
      $(".content-tab-title .heading").click(function (e) {
        e.preventDefault();
        $(this).closest(`.${guideType}`).find(".content-tab-title .heading").removeClass("active");
        $(this).addClass("active");
        var slideno = $(this).data("count");
        $(this).closest(`.${guideType}`).find(".content-wrapper").slick("slickGoTo", slideno);
      });
      productSelectButtonAct(document.querySelectorAll(`.${guideType} .content-wrapper .product-select-button a.Button`));
    }
  }
  
  const showGuideBox = (guideId) => {
    filterAsModal.classList.add("hide");
    document.querySelector(guideId).classList.remove("mfp-hide");
  };
  
  const hideGuideBox = (guideId) => {
    filterAsModal.classList.remove("hide");
    document.querySelector(guideId).classList.add("mfp-hide");
  };
  
  if (PopupDismiss) {
    PopupDismiss.forEach((closeBtn) => {
      closeBtn.removeAttribute("href");
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        
        let allclassList = e.target.classList;
        if (allclassList.contains("BodyType__GuideDismiss")) {
          hideGuideBox("#BodyType__Guide");
        } else if (allclassList.contains("hip__GuideDismiss")) {
          hideGuideBox("#hip__Guide");
        } else if (allclassList.contains("ShoulderType__GuideDismiss")) {
          hideGuideBox("#ShoulderType__Guide");
          document.querySelector('.ProductSize__Elements.ProductSize__ShirtSize').scrollIntoView();
        } else if (allclassList.contains("PreferredFit__GuideDismiss")) {
          hideGuideBox("#PreferredFit__Guide");
          if (window.innerWidth < 768 && productInfo.product_vendor == "Bombay Shirt Company") {
            $(".PreferredFit__GuidePopup .content-wrapper").html(PreferredFitCode);
          }
          document.querySelector('.ProductSize__Elements.ProductSize__PreferredFit').scrollIntoView();
        } else if (closeBtn.classList.contains("HeightSize__GuideDismiss")) {
          if (window.innerWidth < 768) {
            $('.ProductForm__Size').show();
            document.querySelector('#HeightSize__Guide').classList.add('mfp-hide');
            document.querySelector('.ProductSize__Elements.ProductSize__Height').scrollIntoView({block: "center",inline: 'center'});
          }
        } else if (closeBtn.classList.contains("ShirtSize__GuideDismiss")) {
          if (window.innerWidth < 768) {
            $('.ProductForm__Size').show();
            document.querySelector('#ShirtSize__Guide').classList.add('mfp-hide');
            document.querySelector('.ProductSize__Elements.ProductSize__ShirtSize').scrollIntoView({block: "center",inline: 'center'});
          } 
        }
        // setTimeout(function(){
        // $("body").removeClass("edit_size_drawer");
        // },200);
          
      });
    });
  }
  
  setTimeout(() => {
    const guideClickEvent = filterAsModal.querySelectorAll("a.Link____Guide");
    if (guideClickEvent && filterAsModal) {
      guideClickEvent.forEach((clickEvent) => {
        if (
          clickEvent.classList.contains("BodyType__Guide") ||
          clickEvent.classList.contains("hip__Guide") ||
          clickEvent.classList.contains("ShoulderType__Guide") ||
          clickEvent.classList.contains("PreferredFit__Guide")
        ) {
          clickEvent.removeAttribute("href");
          clickEvent.style.cursor = "pointer";
        }
        if (
          clickEvent.classList.contains("ShirtSize__Guide") ||
          clickEvent.classList.contains("HeightSize__Guide")
        ) {
          if (window.innerWidth < 768) {
            clickEvent.removeAttribute("href");
            clickEvent.style.cursor = "pointer";
            clickEvent.classList.remove("ShirtSize__Guide");
            clickEvent.classList.remove("HeightSize__Guide");
          }
        }
        clickEvent.addEventListener("click", (e) => { console.log('click');
          e.stopPropagation();
          e.preventDefault(); 
          let allclassList = e.target.classList;
          if (allclassList.contains("BodyType__Guide")) { 
            buildSlider("BodyType__GuidePopup");
            showGuideBox("#BodyType__Guide" );
          } else if (allclassList.contains("hip__Guide")) {
            buildSlider("hip__GuidePopup");
            showGuideBox("#hip__Guide");
          } else if (allclassList.contains("ShoulderType__Guide")) {
            buildSlider("ShoulderType__GuidePopup");
            showGuideBox("#ShoulderType__Guide");
          } else if (allclassList.contains("PreferredFit__Guide")) {
            buildSlider("PreferredFit__GuidePopup");
            showGuideBox("#PreferredFit__Guide");
            document.querySelector('#PreferredFit__Guide').scrollIntoView();
            let hideFirstItem = document.querySelector('.ProductSize__PreferredFit .Property__Field');
            let superSlimContent = document.querySelector('#PreferredFit__Guide .Super-Slim-content');
            if (hideFirstItem && hideFirstItem.classList.contains('hide')) {
              if (superSlimContent) {
                superSlimContent.classList.add('hide');
              }
            }else{
              if (superSlimContent) {
                superSlimContent.classList.remove('hide');
              }
            }
          } else if (allclassList.contains("ShirtSize-mobile")) {
            if (window.innerWidth < 768) {
              $('.ProductForm__Size').hide();
              document.querySelector('#ShirtSize__Guide').classList.remove('mfp-hide');
              document.querySelector('#ShirtSize__Guide').scrollIntoView();
            }
          } else if (allclassList.contains("HeightSize-moile")) {
            if (window.innerWidth < 768) {
              $('.ProductForm__Size').hide();
              document.querySelector('#HeightSize__Guide').classList.remove('mfp-hide');
              document.querySelector('#HeightSize__Guide').scrollIntoView();
            }
          }
        });
      });
    }
  }, 2000);
  
  // const itemSelectBox = (radioClass,guideId,e) =>{
  //   let radioBtn = document.querySelector(radioClass);
  //   let radioBtns = radioBtn.querySelectorAll('input[type="radio"]');
  //   radioBtns.forEach(radio=>{
  //    radio.classList.remove('activeradio');
  //    if (e.target.dataset.value == radio.dataset.value) {
  //       radio.click();
  //       hideGuideBox(guideId);
  //       if (guideId == '#PreferredFit__Guide' && window.innerWidth < 768 && productInfo.product_vendor == "Bombay Shirt Company") {
  //         $(".PreferredFit__GuidePopup .content-wrapper").html(PreferredFitCode);
  //       }
  //     }
  //   })
  // }
  
  const productSelectButtonAct = (productSelectButton) => {
    if (productSelectButton) {
      productSelectButton.forEach(btn=>{
        btn.addEventListener('click',(e)=>{
          e.preventDefault();
          let closest = e.target.closest('.ProductForm-Filter-Popup');
          if (closest) {
            if (closest.classList.contains('BodyType__GuidePopup')) {
             itemSelectBox('.ProductSize__Elements.ProductSize__BodyType','#BodyType__Guide',e);
            }else if (closest.classList.contains('hip__GuidePopup')) {
             itemSelectBox('.ProductSize__Elements.ProductSize__Hip','#hip__Guide',e);
            }else if(closest.classList.contains('ShoulderType__GuidePopup')){
              itemSelectBox('.ProductSize__Elements.ProductSize__ShoulderType','#ShoulderType__Guide',e);
              document.querySelector('.ProductSize__Elements.ProductSize__ShirtSize').scrollIntoView();
            } 
            else if(closest.classList.contains('PreferredFit__GuidePopup')){
              itemSelectBox('.ProductSize__Elements.ProductSize__PreferredFit','#PreferredFit__Guide',e);
              document.querySelector('.ProductSize__Elements.ProductSize__PreferredFit').scrollIntoView();
            } 
          }
        })
      })
    }
  }
  
  let productSelectButton = document.querySelectorAll('.product-select-button a.Button');
  if (productSelectButton && window.innerWidth >= 768) {
    productSelectButtonAct(productSelectButton);
  }
  
  let popupWithForm = document.querySelector(".popup-with-form");

  // Start - Start of if condition for BSC and Korra template 
  // open size chart on addtocart 

  let productAddtoCart = document.querySelector('.product-handle-button #addtocart-handle');
  if (productAddtoCart) {
    productAddtoCart.addEventListener("click", (event) => {
      event.preventDefault();
      $('[id="addtocart"]').click();
    });
  }
  
    // End - End of if condition for BSC and Korra template 
  
  let thefitsmartObject = localStorage.getItem("fitsmartobjNew");
  let fitsmartButton = document.querySelectorAll('.bombay-shirt-content .fitsmart-button');
  //console.log('fitsmartButton==',fitsmartButton)
  const updateLocalValue = () => {
    thefitsmartObject = localStorage.getItem("fitsmartobjNew");
    console.log('thefitsmartObject=',thefitsmartObject)
    console.log('valueUpdated',thefitsmartObject);
    if (thefitsmartObject) {
      const getDataOfLocal = ()=> {
        if (fitsmartButton) { console.log('fitsmartButton==',fitsmartButton)
          fitsmartButton.forEach(item=>{
            //item.querySelector('.fitsmart-info').innerHTML = 'Your custom size is saved with us.';
            item.querySelector('.button-text').innerHTML = 'Edit Size';
          });
          $('.hidden-tablet-and-up.sel_size').addClass('hide');
          $('.hidden-phone.sel_size').addClass('hide');
          $('.product-handle-button').removeClass('hide');
          $('.fitsmart-button').removeClass('hide');
        }
        if (document.querySelector('.back-git-text')) {
          document.querySelector('.back-git-text').innerText = 'Free Alterations';
        }
        document.querySelector('.ProductForm-Filter .ProductForm__Size').classList.add('customer_ProductForm__Size');
        $('.ProductForm__SavedSize').removeClass('hide');
         $('.Fitsmart-Size').removeClass('hide');
          //$('.ProductForm__SizeContent').addClass('hide-ProductForm-allcontent');
          if($('.ProductForm').hasClass('bsc')){
          //$('.ProductSize__Elements.ProductSize__PreferredFit').addClass('hide');
          }
      }

    
      var thefitsmartValue = JSON.parse(thefitsmartObject);
      if($('.template-bsc').length > 0){
        thefitsmartValue = thefitsmartValue.find(item=>{
          if (item.category == "shirt") {
            return item;
          }
        });
        if (thefitsmartValue) {
          getDataOfLocal();
        }else{
          $('.ProductForm__SizeContent').removeClass('hide-ProductForm-allcontent');
        }
      }else if($('.template-semi-stitched').length > 0){
          var productType = $('body').attr('data-type');
          var thefitsmartValue = jQuery.grep(thefitsmartValue, function( n, i ) {
          var profileCategory = n.category;
          console.log('profileCategory',profileCategory);
          return (profileCategory == productType);
          });
          thefitsmartValue = thefitsmartValue[0];
           console.log('flocalDataOnLoad',thefitsmartValue);
          if (thefitsmartValue) {
            getDataOfLocal();
          }else{
            $('.ProductForm__SizeContent').removeClass('hide-ProductForm-allcontent');
          }
      }

      if (thefitsmartValue) {
        console.log("guest trigger edit on refresh",thefitsmartValue)
        if (thefitsmartValue["_Body Type?"] && !document.querySelector(`.edit-display-size input[name="properties[_Body Type?]"][value="${thefitsmartValue["_Body Type?"]}"]`)?.classList.contains('activeradio')) {
          document.querySelector(`.edit-display-size input[name="properties[_Body Type?]"][value="${thefitsmartValue["_Body Type?"]}"]`).click();
        }
        if (thefitsmartValue["_Shirt Size?"] && !document.querySelector(`.edit-display-size input[name="properties[_Shirt Size?]"][value="${thefitsmartValue["_Shirt Size?"]}"]`)?.classList.contains('activeradio')) {
          setTimeout(function(){document.querySelector(`.edit-display-size input[name="properties[_Shirt Size?]"][value="${thefitsmartValue["_Shirt Size?"]}"]`).click();},500);
        }
        if (thefitsmartValue["_Shoulder Type?"] && !document.querySelector(`.edit-display-size input[name="properties[_Shoulder Type?]"][value="${thefitsmartValue["_Shoulder Type?"]}"]`)?.classList.contains('activeradio')) {
          setTimeout(function(){document.querySelector(`.edit-display-size input[name="properties[_Shoulder Type?]"][value="${thefitsmartValue["_Shoulder Type?"]}"]`).click();},500);
        }
        if (thefitsmartValue["_Height?"] && !document.querySelector(`.edit-display-size input[name="properties[_Height?]"][value="${thefitsmartValue["_Height?"]}"]`)?.classList.contains('activeradio')) {
        document.querySelector(`.edit-display-size input[name="properties[_Height?]"][value="${thefitsmartValue["_Height?"]}"]`).click();
        }
        if (thefitsmartValue["_Size?"] && !document.querySelector(`.edit-display-size input[name="properties[_Size?]"][value="${thefitsmartValue["_Size?"]}"]`)?.classList.contains('activeradio')) {
            setTimeout(function(){document.querySelector(`.edit-display-size input[name="properties[_Size?]"][value="${thefitsmartValue["_Size?"]}"]`).click();},500);
        }
        if (thefitsmartValue["_Preferred Fit?"] && !document.querySelector(`.edit-display-size input[name="properties[_Preferred Fit?]"][value="${thefitsmartValue["_Preferred Fit?"]}"]`)?.classList.contains('activeradio')) {
          setTimeout(function(){document.querySelector(`.edit-display-size input[name="properties[_Preferred Fit?]"][value="${thefitsmartValue["_Preferred Fit?"]}"]`).click();},500);
        }
        // if (thefitsmartValue["_Hip?"] && thefitsmartValue["_Hip?"] != 'NA' && !document.querySelector(`.edit-display-size input[name="properties[_Hip?]"][value="${thefitsmartValue["_Hip?"]}"]`)?.classList.contains('activeradio')) {
        //   document.querySelector(`.edit-display-size input[name="properties[_Hip?]"][value="${thefitsmartValue["_Hip?"]}"]`).click();
        // }

         if($('body').attr('data-type') == 't-shirts' || $('body').attr('data-type') == 'knitpants' || $('body').attr('data-type') == 'jackets'){
        }else{
           if (thefitsmartValue["_Silhouette?"] && !document.querySelector(`.edit-display-size input[name="properties[_Silhouette?]"][value="${thefitsmartValue["_Silhouette?"]}"]`)?.classList.contains('activeradio')) {
            setTimeout(function(){document.querySelector(`.edit-display-size input[name="properties[_Silhouette?]"][value="${thefitsmartValue["_Silhouette?"]}"]`).click();},500);
          }
        }
        
      }
    }else{
      
      $('.hidden-phone.sel_size').removeClass('hide');
      $('.hidden-tablet-and-up.sel_size').removeClass('hide');
    }
  }
   if($('.notlogged').length > 0){
  updateLocalValue();
        }
  
  let forgotPasswordBtn = document.querySelector('.ProductForm-Filter .Shop-Before_login .Form__Forgot');
  let backToLoginBtn = document.querySelector('.ProductForm-Filter .Shop-Before_login .back-to-login-btn');
  let customerLoginForm = $('.ProductForm-Filter .Shop-Before_login #customer_login');
  let recoverCustomerPassword = $('.ProductForm-Filter .Shop-Before_login #recover_customer_password');
  if (forgotPasswordBtn) {
    forgotPasswordBtn.addEventListener('click',(e)=>{
      e.preventDefault();
      customerLoginForm.hide();
      recoverCustomerPassword.show();
    })
  }
  
  if (backToLoginBtn) {
    backToLoginBtn.addEventListener('click',(e)=>{
      e.preventDefault();
      customerLoginForm.show();
      recoverCustomerPassword.hide();
    })
  }
  
  $(document).ready(function () {
    $('.popup-with-form').magnificPopup({
      type: 'inline',
      preloader: false,
      focus: '#name',
      closeOnBgClick: false,
      mainClass: 'my-mfp-slide-bottom',
      callbacks: {
        
        beforeOpen: function () {
          if ($(window).width() < 700) {
            this.st.focus = false;
          } else {
            this.st.focus = '#name';
          }
          document.querySelector('.ProductForm__SizeLabel .single-closer').click();
          $('.pro-nex-prev').addClass('hide');
          CustomOpenModalEvent();
        },
        close: function(){
          $('html').removeClass('Popup_Open');
          $('.pro-nex-prev').removeClass('hide');
           if (window.innerWidth > 768) {
          setTimeout(() => {
            if($('.logged').length > 0){
              window.GetCustomerAct(fitsmartCustomerId,true);
            }else{
              updateLocalValue();
            }
          }, 500);
        }
          CustomCloseModalEvent();
        }
      }
    });
  
    if (window.innerWidth < 768) { 
      $(window).scroll(function() {
        if($('#shopify-section-product-recommendations').length > 0){
        var stopScroll = $('#shopify-section-product-recommendations').offset().top;
        if ($(window).scrollTop() > stopScroll) {
          $('.bombay-shirt-content .addtocart-container').css("bottom", "-135px");
        }else{
          $('.bombay-shirt-content .addtocart-container').css("bottom", "0");
        }
      }
      });
    }
  });

  // let korraSaveCustomSize = document.querySelectorAll('.korra-save-custom-size');
  // if (korraSaveCustomSize) {
  //   korraSaveCustomSize.forEach((korracustomsize)=>{
  //     korracustomsize.addEventListener('click',(e)=>{
  //       console.log('click of atc')
  //       let i = 0;
  //       let ScrollToElement = true;
  //       let Elements = e.target.closest('.find-js-closest');
  //       console.log('Elements',Elements)
  //       Elements = $('.ProductSize__Elements', Elements);
  //       Elements.each(function(index){
  //         if($(this).hasClass('active')){
  //           i++;
  //         } else {
  //           console.log('in customise')
  //           $(this).find('.ProductElements__Name span.error').removeClass('hide');
  //           if(ScrollToElement){
  //             console.log('nt',ScrollToElement)
  //             let scrollEl = $(this);
  //             scrollEl[0].scrollIntoView({behavior: "smooth",block: "center",inline: 'center'});
  //             ScrollToElement = false;
  //           }
  //           return false;
  //         }
  //       });
  //       if(i < Elements.length){
  //         console.log('fdfd')
  //         return false;
  //       } else {
  //         if (window.innerWidth < 768) {
  //           $('.new_measure_mobile').hide();
  //           $('.korra_size').show();
  //           return;
  //         }
  //         $('.korra_size_chart').removeClass('customise-background');
  //         $('.ProductForm__Size').removeClass('customise-new_measure');
  //         $(".ProductForm-Filter").animate({ scrollTop: 0 }, "slow");
  //       }
  //                var loadImg_korra = document.querySelectorAll("img.lazyimg_korra");
  //        console.log('loadkorra img');
  //        loadImg_korra.forEach(function(img) {
  //         img.src = img.dataset.imgsrc;
  //         img.classList.remove('lazyimg_korra');            
  //        });
  //     })
  //   })
  // }
  
  let GreatChoiseDismiss = document.querySelector('.Great__ChoiseDismiss');
  if (GreatChoiseDismiss) {
    GreatChoiseDismiss.addEventListener('click',(e)=>{
      document.querySelector('#great-choice .mfp-close').click();
      //         if (window.innerWidth < 768) {
      // setTimeout(() => {
      // if($('.logged').length > 0){
      //   window.GetCustomerAct(fitsmartCustomerId,true);
      // }else{
      //   updateLocalValue();
      // }
      // }, 500);
      // }
    })
  }
  
  let continueShoppingLink = document.querySelector('.continue__shopping_link');
  if (continueShoppingLink) {
    continueShoppingLink.addEventListener('click',(e)=>{
      if($('body').hasClass('open_semicustom')){
        setTimeout(function(){
        $('.pro-nex-prev').addClass('hide');
        },100)
        
      }else{
        $('.pro-nex-prev').removeClass('hide');
      }
      document.querySelector('#great-choice .mfp-close').click();
      //         if (window.innerWidth < 768) {
      // setTimeout(() => {
      // if($('.logged').length > 0){
      //   window.GetCustomerAct(fitsmartCustomerId,true);
      // }else{
      //   updateLocalValue();
      // }
      // }, 500);
      // }
    })
  }
  
  
  $(document).on('click', function(e) {
    if (customDrawer.classList.contains('open') && 
      !document.querySelector('.Product__InfoWrapper .Product__Info')?.contains(e.target) && 
      !customDrawer.contains(e.target) &&
      !document.querySelector('.mfp-content')?.contains(e.target) &&
      !document.querySelector('.Exit_Popup')?.contains(e.target)) {
      document.querySelector('.ProductForm__SizeLabel .single-closer')?.click();
    }
  })

  if (window.location.search == '?productFormfilter=true') {
    $('.get-size-button').click();
    setTimeout(() => {
      // replaceState 
      let uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        let clean_uri = uri.substring(0,uri.indexOf("?"));
        window.history.replaceState({},document.title, clean_uri);
      }
    },1000 * 15);
  }
  
  let ProductFormViewCart = document.querySelector('.ProductForm__ViewCart');
  if (ProductFormViewCart) {
    ProductFormViewCart.addEventListener('click',(e)=>{
      // window.GetCustomerAct(fitsmartCustomerId,true);
      getCustomerCustom(fitsmartCustomerId,true);
      window.location.href = '/cart'; //Will take you to Cart Page.
    })
  }

    var activeElem1 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem1 = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
    var progressData1 = activeElem1/totalElem1*100;

    $('.fit_progressbar span').css('width',progressData1+'%');
    $('.selFit').html(activeElem1);
    $('.totFit').html(totalElem1);
  $('.Im-New-Filter .ProductSize__Elements').click(function(){
    setTimeout(function(){
    var activeElem = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements.active').length;
    var totalElem = document.querySelectorAll('.Im-New-Filter .ProductSize__Elements').length;
    var progressData = activeElem/totalElem*100;
  console.log('activeElem11',activeElem);
  console.log('totalElem11',totalElem);
    $('.fit_progressbar span').css('width',progressData+'%');
    $('.selFit').html(activeElem);
    $('.totFit').html(totalElem);
    
    if(activeElem == totalElem){
      console.log('removedisable')
        $('.calculateSize').removeClass('disCalculatebtn');
    }else{
       console.log('adddisable')
        $('.calculateSize').addClass('disCalculatebtn');
    }
  },500)
});

function createMeasurement1(data1){
      console.log('createdata',data1);
    let createMeasureOBJ = {
      "shopifyId": fitsmartCustomerId,
      "email": email,
      "metadata": customerMetaKey,
      "requests": data1
    }
    console.log("createMeasureOBJ",createMeasureOBJ);
    console.log(data1.length);
    console.log(`${baseUrlBsc}`);
  
    $.ajax({
      // url: baseUrlBsc+ '/sizing/v2/create-measurement',
      url: baseUrlBsc+ '/sizing/v4/createMeasurmentShopify',
      type: 'POST',
      data: JSON.stringify(createMeasureOBJ),
      contentType: "application/json",
      dataType: "json",
      headers: requestToken,
      success: function(data, textStatus, xhr) {
        response = data;
        console.log('create measure success');
          $('.scan-success-loader img').hide();
          $('#animation_only_Scan,.scan_text').hide();
          setTimeout(function(){
             var animationBlastTick = document.getElementById("animation_blast_tick");
             console.log('animationBlastTick',animationBlastTick)
             $('#animation_blast_tick,.blast_text').show();
             animationBlastTick.play();
          },500)
      },complete: function(xhr, textStatus) {
        if(xhr.status == 200){
          if(response.success != null){
            isProfileCreated = true;
            $.magnificPopup.instance.close();
            console.log('fitsmartCustomerId',fitsmartCustomerId)
            asyncFlag = true;
            asyncAPI = true;
            // window.GetCustomerAct(fitsmartCustomerId,true);
            getCustomerCustom(fitsmartCustomerId,true);
          }else{
            if(response.error.errorCode == "406" || response.error.errorCode == "500"){
              console.log("error code 406>>>",response.error);
              var fetchURL = `${window.location.href}`;
              fetch(fetchURL,{
              method:'GET', headers: {
              'Content-Type': 'application/json'}
              })
              .then((response) =>{
              return response.text();
              }).then(data =>{
                let parser = new DOMParser();
                let parsedHtml = parser.parseFromString(data, 'text/html');
                customerMetaKey = parsedHtml.querySelector('body').getAttribute("data-customer-key");
                console.log("parsedHtml",parsedHtml,"customerMetaKey",customerMetaKey);
                // debugger;
                createMeasurement1(data1);
              });
            }
          }
        }
    },
      error: function(err) {
        console.log(err)
      }
    });
 // }
}

function createMeasurementForIND_to_USA(data1){
      console.log('createdata',data1);
 // if(data && data.length > 0) {
    console.log(data1.length)
    console.log(`${baseUrlBsc}`);
    $.ajax({
      //url: `${baseUrlBsc}/sizing/v1/create-measurement`,
      url: baseUrlBsc+ '/sizing/v2/create-measurement',
      type: 'POST',
      data: JSON.stringify(data1),
      contentType: "application/json",
      async: false,
      dataType: "json",
      headers: requestToken,
      success: function(data, textStatus, xhr) {
        console.log('create measure success');
          // $('.scan-success-loader img').hide();
          // $('#animation_only_Scan,.scan_text').hide();
          // setTimeout(function(){
          //    var animationBlastTick = document.getElementById("animation_blast_tick");
          //    console.log('animationBlastTick',animationBlastTick)
          //    $('#animation_blast_tick,.blast_text').show();
          //    animationBlastTick.play();
          // },500)
      },complete: function(xhr, textStatus) {
        if(xhr.status == 200){
          isProfileCreated = true;
          // $.magnificPopup.instance.close();
          // console.log('fitsmartCustomerId',fitsmartCustomerId)
          asyncFlag = true;
          asyncAPI = true;
          window.GetCustomerAct(fitsmartCustomerId,true);
        }
    },
      error: function(err) {
        console.log(err)
      }
    });
 // }
}

$('.calculateSize').click(function(){
  $.magnificPopup.instance.close();
 //document.querySelector('.close_sizemodule_drawer').click();
  $('.fitsmart-button').removeClass('hide');
  $('.addtocart-container').removeClass('hide');
  $('.sel_size').addClass('hide');

  if($('.notlogged').length > 0){

   // Start-animation start
     async function asyncCall() {
            $('body').addClass('showAnimation');
            $('.scan-success-loader img').show()
     }
   // End- animation start
    asyncCall();
    console.log('fitsmartObject1nira',fitsmartObject1)
    var bodyType;
    var hipClass;
    var height;
      if(fitsmartObject1 && fitsmartObject1.length){
         bodyType = fitsmartObject1[0]['_Body Type?'];
         hipClass = fitsmartObject1[0]['_Hip?'];
         height = fitsmartObject1[0]['_Height?'];
      }else{
         bodyType = $('.Im-New-Filter input.activeradio[name="properties[_Body Type?]"]').val();
         hipClass = $('.Im-New-Filter input.activeradio[name="properties[_Hip?]"]').val();
         height = $('.Im-New-Filter input.activeradio[name="properties[_Height?]"]').val();
      }

    if($('.template-bsc').length > 0){
        var shirtSize = $('.Im-New-Filter input.activeradio[name="properties[_Shirt Size?]"]').val();
        var shoulderType = $('.Im-New-Filter input.activeradio[name="properties[_Shoulder Type?]"]').val();
        var preferredFit = $('.Im-New-Filter input.activeradio[name="properties[_Preferred Fit?]"]').val();
    }else if($('.template-semi-stitched').length > 0){
       // var korraBodyType = $('input.activeradio[name="properties[_Body Type?]"]').val();
        var subSize = $('.Im-New-Filter input.activeradio[name="properties[_Size?]"]').val();
        var preferredFit = $('.Im-New-Filter input.activeradio[name="properties[_Preferred Fit?]"]').val();
        var silhouetteData;
      if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants' || pdpType_low == 'jackets'){
          silhouetteData = 'NA';
        }else{
          silhouetteData = $('.Im-New-Filter input.activeradio[name="properties[_Silhouette?]"]').val();
        }
    }
    
    setLocalStoreData(bodyType,hipClass,height,shirtSize,shoulderType,preferredFit,subSize,silhouetteData,pdpType_low);
   
 $('.hidden-tablet-and-up.sel_size').addClass('hide');
    $('.product-handle-button').removeClass('hide');
  updateLocalValue();
  }else{
   async function asyncCall() {
          $('body').addClass('showAnimation');
          $('.scan-success-loader img').show()
          //var animationOnlyScan = document.getElementById("animation_only_Scan");
          //animationOnlyScan.play();
   }

    if(pdpType_low == 'shirt'){
        var bodyTypelg = $('input.activeradio[name="properties[_Body Type?]"]').val();
        var shirtSizelg = $('.Im-New-Filter input.activeradio[name="properties[_Shirt Size?]"]').val();
        var shoulderTypelg = $('input.activeradio[name="properties[_Shoulder Type?]"]').val();
        var heightlg = $('input.activeradio[name="properties[_Height?]"]').val();
        var preferredFitlg = $('input.activeradio[name="properties[_Preferred Fit?]"]').val();
        var hipSemi = $('input.activeradio[name="properties[_Hip?]"]').val();
        console.log('shirtSizelg--',shirtSizelg);
          if(shoulderTypelg){
            document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${shoulderTypelg}"]`).click();
          }
          if(shirtSizelg){
            document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${shirtSizelg}"]`).click();
          }
          if(preferredFitlg){
            document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${preferredFitlg}"]`).click();
          }
      
        var bscArr = [];
        var bscData = {
            // "shopifyId": fitsmartCustomerId,
            "gender": "Male",
            "category": "Shirts",
            // "note": "Customer Info stored in notes3",
            // "fitSmartVersion": "3",
            // "measurements": [],
            // "isGuest": false,
            "brand": "BOM",
            "fitSmart": {
                "bodyShape": bodyTypelg,
                "stdSize": shirtSizelg,
                "height": heightlg,
                "fit": preferredFitlg,
                "shoulderType": shoulderTypelg
            }
        }
        // bscData['customerDetails'] = {};
        // bscData['customerDetails']['customerId'] = fitsmartCustomerId;
        // bscData['customerDetails']['firstName'] = firstName;
        // bscData['customerDetails']['lastName'] = lastName;
        // bscData['customerDetails']['email'] = email;
        // if (phone) {
        //     bscData['customerDetails']['phone'] = phone;
        // }
        bscArr.push(bscData);
        asyncCall();
        setTimeout(() => {
           createMeasurement1(bscArr);
        }, 500);
    }else{
        var bodyTypeSemi = $('input.activeradio[name="properties[_Body Type?]"]').val();
        var hipSemi = $('input.activeradio[name="properties[_Hip?]"]').val();
        var shirtSizeSemi = $('.Im-New-Filter input.activeradio[name="properties[_Size?]"]').val().toLowerCase();
        var heightSemi = $('input.activeradio[name="properties[_Height?]"]').val();
        var silhouette = $('input.activeradio[name="properties[_Silhouette?]"]').val();
       var _Preferred_fit = $('input.activeradio[name="properties[_Preferred Fit?]"]').val();
      console.log('silhouette',silhouette)
      console.log('shirtSizeSemi',shirtSizeSemi.toUpperCase())
       if(shirtSizeSemi){
         setTimeout(function(){
            document.querySelector(`.edit_size_module input[name="properties[_Size?]"][value="${shirtSizeSemi.toUpperCase()}"]`).click();
         },500)
       }

        var pdpCat;
        var silhouettePValue;
        if(pdpType_low == 'jeans'){
          pdpCat = "Jeans";
          silhouettePValue = silhouette;
          document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${silhouette}"]`).click();
        } else if(pdpType_low == 'dress pants'){
          pdpCat = "DRESS_PANTS";
          silhouettePValue = silhouette;
          document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${silhouette}"]`).click();
        } else if(pdpType_low == 'neapolitan dress pants'){
          pdpCat = "NEAPOLITAN_DRESS_PANTS";
          silhouettePValue = silhouette;
          document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${silhouette}"]`).click();
        } else if(pdpType_low == 'chinos'){
          pdpCat = "Chinos";
          silhouettePValue = silhouette;
          document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${silhouette}"]`).click();
        } else if(pdpType_low == 't-shirts'){
          pdpCat = "TShirts";
          silhouettePValue = "NA";
        } else if(pdpType_low == 'jackets'){
          pdpCat = "Jackets";
          document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${_Preferred_fit}"]`).click();
        }
        else if(pdpType_low == 'knitpants'){
          pdpCat = "Knitpants";
          silhouettePValue = "NA";
        } else if(pdpType_low == 'linen pants'){
          pdpCat = "LINEN_PANTS";
          silhouettePValue = silhouette;
          document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${silhouette}"]`).click();
        }
         console.log('silhouettePValue',silhouettePValue)
        var semiArr = [];
        if(pdpType_low == 'jackets'){
        var semiData = {
          // "shopifyId": fitsmartCustomerId,
          "gender": "Male",
          "category": pdpCat,
          // "note": null,
          // "fitSmartVersion": "Guest",
          // "isGuest": false,
          "brand": "BOM",
          // "measurements": [],
          "fit": _Preferred_fit,
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi
          },
          "fabricType": "NA"
        }
          console.log("semiData",semiData);
        }else{
        var semiData = {
          // "shopifyId": fitsmartCustomerId,
          "gender": "Male",
          "category": pdpCat,
          // "note": null,
          // "fitSmartVersion": "Guest",
          // "isGuest": false,
          "brand": "BOM",
          // "measurements": [],
          "fit": "NA",
          "fitSmart": {
              "bodyShape": bodyTypeSemi,
              "stdSize": shirtSizeSemi.toLowerCase(),
              "height": heightSemi
          },
          "silhouette": silhouettePValue,
          "fabricType": "NA"
        }
        }
        // semiData['customerDetails'] = {};
        // semiData['customerDetails']['customerId'] = fitsmartCustomerId;
        // semiData['customerDetails']['firstName'] = firstName;
        // semiData['customerDetails']['lastName'] = lastName;
        // semiData['customerDetails']['email'] = email;
        // if (phone) {
        //     semiData['customerDetails']['phone'] = phone;
        // }
        semiArr.push(semiData);
         asyncCall();
         setTimeout(() => {
           createMeasurement1(semiArr);
         }, 500);
    }
  }
})

// add tocart click event for call createMeasurment API
let counterForCreateM = true;
$(document).on("click","button.ProductForm__AddToCart",function(){
  console.log("ProductForm__AddToCart>>>>",$(this));
  if($('.logged').length > 0){
    var bodyTypeConf = $('.edit_profile_module input.activeradio[name="properties[_Body Type?]"]').val();
    var heightConf = $('.edit_profile_module input.activeradio[name="properties[_Height?]"]').val();
    
    var profileArr = [];
    var profileData = {
      // "shopifyId": fitsmartCustomerId,
      "gender": "Male",
      "brand": "NA",
      // "category": "NA",
      // "note": "Customer Info stored in notes",
      // "fitSmartVersion": "3",
      // "measurements": [],
      "fitSmart": {
      "bodyShape": bodyTypeConf,
      "height": heightConf
      }
    }
    // profileData['customerDetails'] = {};
    // profileData['customerDetails']['customerId'] = fitsmartCustomerId;
    // profileData['customerDetails']['firstName'] = firstName;
    // profileData['customerDetails']['lastName'] = lastName;
    // profileData['customerDetails']['email'] = email;
    // if (phone) {
    // profileData['customerDetails']['phone'] = phone;
    // }
    console.log('profileData>>>>>>',profileData);
    
    profileArr.push(profileData);
    
    
    if(pdpType_low == 'shirt'){
      
      var shirtSizelg = $('.edit_size_module input.activeradio[name="properties[_Shirt Size?]"]').val();
      var shoulderTypelg = $('.edit_size_module input.activeradio[name="properties[_Shoulder Type?]"]').val();
      var preferredFitlg = $('.edit_size_module input.activeradio[name="properties[_Preferred Fit?]"]').val();
      
      if(typeof shirtSizelg === "undefined"){
      var shirtSizelg = profileData['0']['fitsmart']['stdSize']['value']; 
      }
      
      if(typeof shoulderTypelg === "undefined" && typeof preferredFitlg === "undefined"){
      var shoulderTypelg = profileData['0']['fitsmart']['shoulderType']['value'];
      var preferredFitlg = profileData['0']['fitsmart']['fit']['value'];  
      }
      var bscData = {
      // "shopifyId": fitsmartCustomerId,
      "gender": "Male",
      "category": "Shirts",
      // "note": "Customer Info stored in notes3",
      // "fitSmartVersion": "3",
      // "measurements": [],
      // "isGuest": false,
      "brand": "BOM",
      "fitSmart": {
      "stdSize": shirtSizelg,
      "fit": preferredFitlg,
      "shoulderType": shoulderTypelg
      }
      }
      // bscData['customerDetails'] = {};
      // bscData['customerDetails']['customerId'] = fitsmartCustomerId;
      // bscData['customerDetails']['firstName'] = firstName;
      // bscData['customerDetails']['lastName'] = lastName;
      // bscData['customerDetails']['email'] = email;
      // if (phone) {
      // bscData['customerDetails']['phone'] = phone;
      // }
      profileArr.push(bscData);
    }
    
    // asyncCall();
    setTimeout(() => {
      if(counterForCreateM == true){
        counterForCreateM = false;
       // createMeasurementForIND_to_USA(profileArr);
      }
    }, 500);
  }
});


$('.change_close,.back-dwr').click(function(){
  $('body').removeClass('edit_size_drawer');
  
  if(fitsmartObject1 != 'undefined'){
      $('.Im-New-Filter .ProductSize__BodyType').hide();
      $('.Im-New-Filter .ProductSize__Height').hide();
      //$('.Im-New-Filter .ProductSize__Hip').hide();
  }

 var editCategory  = $('body').attr('data-type');
  if($('.notlogged').length > 0){
    if(fitsmartObject1 && fitsmartObject1.length){
    var new_editLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
      return (n.category == editCategory);
    });
      var bodyType = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
      var heigthValue = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();                                       
      var shirtSize = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
      var ShoulderType = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
      var preferredFit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();

  
      
    if(new_editLineBSC.length > 0){
      var st_bodyType = new_editLineBSC[0]['_Body Type?'];
      var st_height = new_editLineBSC[0]['_Height?'];

      console.log('new_editLineBSC',new_editLineBSC);
      console.log('st_bodyType',st_bodyType);
      console.log('st_height',st_height);
      

       if(bodyType != st_bodyType){
         document.querySelector(`.edit_profile_module input[name="properties[_Body Type?]"][value="${st_bodyType}"]`).click(); 
        }
       if(heigthValue != st_height){
         document.querySelector(`.edit_profile_module input[name="properties[_Height?]"][value="${st_height}"]`).click(); 
        }
      
      
      if(new_editLineBSC[0]['category'] == 'shirt'){
        var st_size = new_editLineBSC[0]['_Shirt Size?'];
        var st_shType = new_editLineBSC[0]['_Shoulder Type?'];
        var st_fit = new_editLineBSC[0]['_Preferred Fit?'];
        if(shirtSize != st_size){
         document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${st_size}"]`).click(); 
        }
        if(ShoulderType != st_shType){
         document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${st_shType}"]`).click(); 
        }
        if(preferredFit != st_fit){
         document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${st_fit}"]`).click(); 
        }
      }
    }
      var userBody = fitsmartObject1[0]['_Body Type?'];
      console.log("userBody",userBody);
     if(userBody == 'healthy'){
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxxl"]').closest('.Property__Field').removeClass('hide');

      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').removeClass('hide');
      
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xs"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="s"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xxl"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xxxl"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="4xl"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="5xl"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="6xl"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="7xl"]').closest('.Property__Field').removeClass('hide');
      }if(userBody == 'average'){ 
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').removeClass('hide'); 
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').removeClass('hide');        
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').addClass('hide'); 
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').addClass('hide'); 
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').addClass('hide'); 
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').addClass('hide'); 
        
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xs"]').closest('.Property__Field').removeClass('hide'); 
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="s"]').closest('.Property__Field').removeClass('hide');  
        
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="4xl"]').closest('.Property__Field').addClass('hide'); 
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="5xl"]').closest('.Property__Field').addClass('hide'); 
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="6xl"]').closest('.Property__Field').addClass('hide'); 
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="7xl"]').closest('.Property__Field').addClass('hide'); 
      }else{
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxxl"]').closest('.Property__Field').addClass('hide');

      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').addClass('hide');

      if(pdpType_low != 'jackets'){
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xs"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="s"]').closest('.Property__Field').removeClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xxl"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="xxxl"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="4xl"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="5xl"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="6xl"]').closest('.Property__Field').addClass('hide');
      $('.newsizepopup .ProductSize__newShirtSize [type="radio"][value="7xl"]').closest('.Property__Field').addClass('hide');
      }
      }
    }
      
  }else{
      console.log("fitSmartProfiles",fitSmartProfiles);
       var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
        return (n.categoryName == editCategory);
      });
        console.log("profileData",profileData);
        console.log("editCategory",editCategory);
    
        if(profileData.length && profileData[0].category == 'Shirts'){

        var bodyType = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        var heigthValue = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();                                       
        var shirtSize = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
        var ShoulderType = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
        var preferredFit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
           

         var st_bodyType = profileData[0].fitsmart.bodyShape.value;
         var st_height = profileData[0].fitsmart.height.value;
         var shirtSize1 = profileData[0].fitsmart.stdSize.value;
         var ShoulderType1 = profileData[0].fitsmart.shoulderType.value;
         var preferredFit1 = profileData[0].fitsmart.fit.value;

           if(bodyType != st_bodyType){
             document.querySelector(`.edit_profile_module input[name="properties[_Body Type?]"][value="${st_bodyType}"]`).click(); 
            }
           if(heigthValue != st_height){
             document.querySelector(`.edit_profile_module input[name="properties[_Height?]"][value="${st_height}"]`).click(); 
            }
            if(shirtSize != shirtSize1){
             document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${shirtSize1}"]`).click(); 
            }
            if(ShoulderType != ShoulderType1){
             document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${ShoulderType1}"]`).click(); 
            }
            if(preferredFit != preferredFit1){
             document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${preferredFit1}"]`).click(); 
            }
          
        }
    
  }
})

$(document).ready(function(){
  if($('.notlogged').length > 0){
     viewUpdateTable();
  }else{
       loginViewUpdateTable();
    // if(fitSmartProfiles && fitSmartProfiles.length){
    // var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
    //   return (n.categoryName == pdpTypeLow) ;
    // });
    // console.log('profileDataNN',profileData);
      
    // if(profileData.length > 0){
    //    $('.hidden-tablet-and-up.sel_size').addClass('hide');
    //       $('.hidden-phone.sel_size').addClass('hide');
    //       $('.product-handle-button').removeClass('hide');
    //       $('.fitsmart-button').removeClass('hide');
    //     if(profileData[0].category == 'Shirts') {
    //       var st_size = profileData[0].fitsmart.stdSize.value;
    //       var st_shType = profileData[0].fitsmart.shoulderType.value;
    //       var st_fit = profileData[0].fitsmart.fit.value;
    //       console.log('st_fit',st_fit)
    //       var sizeData = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
    //       var shData = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
    //       var fitData = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
    //       console.log('fitData',fitData)
    //       // console.log('sizeData',sizeData);console.log('shData',shData);console.log('fitData',fitData);
          
    //       if(shData != st_shType){
    //         document.querySelector(`.edit_size_module input[name="properties[_Shoulder Type?]"][value="${st_shType}"]`).click();
    //       }
    //       if(sizeData != st_size){
    //         document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${st_size}"]`).click();
    //       }
    //       if(fitData != st_fit){
    //         document.querySelector(`.edit_size_module input[name="properties[_Preferred Fit?]"][value="${st_fit}"]`).click();
    //       }
          
    //     }else{
    //       var st_semisize = profileData[0].fitsmart.stdSize.value;
      
    //       $('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+st_semisize.toUpperCase()+'"]').click();
    //       $('input[type="hidden"][name="properties[_Size?]"]').val(st_semisize.toUpperCase());
    //       $('.profile_size_semi').html(st_semisize.toUpperCase());
    //       $('.contBtnDrawer').show();
    //       $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
    //       recommendedSize = st_semisize.toUpperCase();
    //       var sizeData = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
    //       if(sizeData != st_semisize){
    //         document.querySelector(`.edit_size_module input[name="properties[_Size?]"][value="${st_semisize.toUpperCase()}"]`).click();
    //       }
    //      if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
    //         var silhouette = "NA";
    //       } else {
    //         var st_silhouette = profileData[0].fitsmart.silhouette.value;
    //         var silhouette = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
    //          $('.profile_sil_semi').html(st_silhouette);
    //          if(silhouette != st_silhouette){ 
    //           console.log('edit data condition true')
    //           document.querySelector(`.edit_size_module input[name="properties[_Silhouette?]"][value="${st_silhouette}"]`).click();
    //         }
    //       }
    //     } 
    //   } else {
    //     $('.sel_size').removeClass('hide');
    //    $('.data_drawer_two').addClass('hide');

    //     $('.data_drawer_one').removeClass('hide');
    //   }
    // }
  }  
})
 
$('.edit_profile_data').click(function(){ 
if($('.logged').length > 0){
  if(fitSmartProfiles.length){
    var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
      return (n.categoryName == pdpTypeLow) ;
    });

    console.log('editLineBSC',profileData);
    console.log('profileAPIData',profileAPIData);
    if(profileData.length > 0){ 
         var st_bType = profileAPIData.profileFitsmart.bodyShape;
         var st_height = profileAPIData.profileFitsmart.height;
         var st_hip = profileAPIData.profileFitsmart.hipClass;

         // var st_korrasize = editLineBSC[0]['_Size?']; 
         // $('.profile_size_korra').html(st_korrasize);  
       
   var bTypeData = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
   var heightData = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
   var hipData = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
      
    if(bTypeData!=st_bType){
      document.querySelector(`input[name="properties[_Body Type?]"][value="${st_bType}"]`).click();
    }
    if(heightData!=st_height){
      document.querySelector(`input[name="properties[_Height?]"][value="${st_height}"]`).click();
     }
     // if(hipData!=st_hip){
     //  document.querySelector(`input[name="properties[_Hip?]"][value="${st_hip}"]`).click();
     // }
    }else{
      $('.sel_size').removeClass('hide');
    }
    
   } 
}

  $('.edit_module_heading').text('Edit Profile');
  $('.edit_module_sizenote').text('Changing profile will reset the measurements of all categories of products.');
  
    // $('.data_drawer_three').removeClass('hide');
    // $('.edit_profile_module').removeClass('hide');
    //  $('.data_drawer_two').addClass('hide');
    $('body').addClass('edit_size_drawer');
    
    // $('.ProductSize__BodyType').show();
    // $('.ProductSize__Height').show();
    
    $('.edit_profile_module').removeClass('hide');
    $('.edit_size_module').addClass('hide');

    $('.save_edited_change').addClass('edit_profile_button');
    $('.save_edited_change').removeClass('edit_size_button');

    $('.confirmChangesBtn').addClass('edit_profile_confirm');
    $('.confirmChangesBtn').removeClass('edit_size_confirm');
  
  // Start - Button status change, when element change 
  $('.edit_data_module .bottom-button-set a').addClass('btn-disable-edit');
  
   $('.edit_data_module .edit_profile_module .ProductSize__Elements [type="radio"]').click(function(){
     if($('.notlogged').length > 0){
       
        fitsmartObject1 = localStorage.getItem("fitsmartobjNew");
        fitsmartObject1 = JSON.parse(fitsmartObject1);
        console.log('fitsmartObject1==',fitsmartObject1.length)
       var bodyTypeData1 = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
       var heigthData1 = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
       var hip1 = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
       
       var editCategory  = $('body').attr('data-type');
       if(fitsmartObject1.length == 1){
            var st_bType = fitsmartObject1[0]['_Body Type?'];
            var st_height = fitsmartObject1[0]['_Height?'];
            var st_hip = fitsmartObject1[0]['_Hip?'];
       } else{
          var editLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
           return (n.category == editCategory);
          });
          if(editLineBSC.length){
            var st_bType = editLineBSC[0]['_Body Type?'];
            var st_height = editLineBSC[0]['_Height?'];
            var st_hip = editLineBSC[0]['_Hip?'];
          } else {
            var st_bType = fitsmartObject1[0]['_Body Type?'];
            var st_height = fitsmartObject1[0]['_Height?'];
            var st_hip = fitsmartObject1[0]['_Hip?'];
          }
       } 
        var imageArray = {'bodyType':st_bType,'height':st_height};
        var currArray = {'bodyType':bodyTypeData1,'height':heigthData1};

        var activeBodytype = $('.edit_profile_module .ProductSize__BodyType [type="radio"]').hasClass('activeradio');
        var activeHeight = $('.edit_profile_module .ProductSize__Height [type="radio"]').hasClass('activeradio');
        var activeHip = $('.edit_profile_module .ProductSize__Hip [type="radio"]').hasClass('activeradio');
       
        if(JSON.stringify(imageArray) === JSON.stringify(currArray) || activeBodytype == false || activeHeight == false ){ 
          $('.edit_data_module .bottom-button-set a.edit_profile_button').addClass('btn-disable-edit');
        }else{ 
          $('.edit_data_module .bottom-button-set a.edit_profile_button').removeClass('btn-disable-edit');
        }
     }else{
    var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
      return (n.categoryName == pdpTypeLow) ;
    });
        var bodyTypeDatalg = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        var heigthDatalg = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
        var hipDatalg = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();

        var st_bType = profileAPIData.profileFitsmart.bodyShape;
        var st_height = profileAPIData.profileFitsmart.height;
        var st_hip = profileAPIData.profileFitsmart.hipClass;
 
        var imageArray = {'bodyType':st_bType,'height':st_height};
        var currArray = {'bodyType':bodyTypeDatalg,'height':heigthDatalg};

        var activeBodytype = $('.edit_profile_module .ProductSize__BodyType [type="radio"]').hasClass('activeradio');
        var activeHeight = $('.edit_profile_module .ProductSize__Height [type="radio"]').hasClass('activeradio');
        var activeHip = $('.edit_profile_module .ProductSize__Hip [type="radio"]').hasClass('activeradio');
        
        if(JSON.stringify(imageArray) === JSON.stringify(currArray) || activeBodytype == false || activeHeight == false){ 
          $('.edit_data_module .bottom-button-set a.edit_profile_button').addClass('btn-disable-edit');
        }else{ 
          $('.edit_data_module .bottom-button-set a.edit_profile_button').removeClass('btn-disable-edit');
        }
     }
   })
  // End - Button status change, when element change
   
})

$('.edit_size_data').click(function(){
  console.log('hi size')

// if($('.notlogged').length > 0){
// }else{

//   var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
//   return (n.categoryName == pdpTypeLow);
//   });
//   if(profileData.length && profileData[0].category == 'Jackets'){
//      var Size1 = profileData[0].fitsmart.stdSize.value;
//     console.log("Size1",Size1);
//      var st_size = $('.edit_data_module [name="properties[_Size?]"].activeradio').val();
//     if(Size1!=st_size){
//        $('.edit_data_module .ProductSize__Elements [name="properties[_Size?]"][value="'+Size1+'"]').click();
//     }
    
//   }
// }
         
  var productType = $('#Filter_As_Modal').attr('data-prodtype');
  $('.edit_module_heading').text('Edit '+productType+' Sizing');
  $('.edit_module_sizenote').text('This updated sizing will applied to all your open orders and items in cart');

  
  // $('.data_drawer_three').removeClass('hide');
  // $('.edit_module_size').removeClass('hide');
  //  $('.data_drawer_two').addClass('hide');
  $('body').addClass('edit_size_drawer');
  $('.edit_size_module').removeClass('hide');
  $('.edit_profile_module').addClass('hide');
  
  $('.save_edited_change').addClass('edit_size_button');
  $('.save_edited_change').removeClass('edit_profile_button');
  
  $('.confirmChangesBtn').addClass('edit_size_confirm');
  $('.confirmChangesBtn').removeClass('edit_profile_confirm');
  
  // Start - Button status change, when element change
  $('.edit_data_module .bottom-button-set a').addClass('btn-disable-edit');

  $('.edit_data_module .edit_size_module .ProductSize__Elements [type="radio"]').click(function(){
    console.log('hi size assfsf')
     if($('.notlogged').length > 0){
      fitsmartObject1 = localStorage.getItem("fitsmartobjNew");
      fitsmartObject1 = JSON.parse(fitsmartObject1);

      var shirtSize = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
      var ShoulderType = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
      var preferredFit = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();

     
      var editCategory  = $('body').attr('data-type');
      var editLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
          return (n.category == editCategory);
        });
        console.log('editLineBSC',editLineBSC);
       var st_bodyType = editLineBSC[0]['_Body Type?'];
       var st_height = editLineBSC[0]['_Height'];
        
      if(editLineBSC.length > 0){
      if(editLineBSC[0]['category'] == 'shirt'){
          var st_size = editLineBSC[0]['_Shirt Size?'];
          var st_shType = editLineBSC[0]['_Shoulder Type?'];
          var st_fit = editLineBSC[0]['_Preferred Fit?'];

          
          // $('.change_close,.back-dwr').click(function(){
          //  document.querySelector(`.edit_size_module input[name="properties[_Shirt Size?]"][value="${st_size}"]`).click();
          //   console.log("st_size___",st_size);
          //   console.log("st_shType",st_shType);
          //   console.log("st_fit",st_fit);
          // });
  
          var sizeArray = {'st_size':st_size,'st_shType':st_shType,'st_fit':st_fit};
          var currArray = {'st_size':shirtSize,'st_shType':ShoulderType,'st_fit':preferredFit};

          var activeSize = $('.edit_size_module .ProductSize__ShirtSize [type="radio"]').hasClass('activeradio');
          var activeShoulderType = $('.edit_size_module .ProductSize__ShoulderType [type="radio"]').hasClass('activeradio');
          var activePreferredFit = $('.edit_size_module .ProductSize__PreferredFit [type="radio"]').hasClass('activeradio');
         
          if(JSON.stringify(sizeArray) === JSON.stringify(currArray) || activeSize == false || activeShoulderType == false || activePreferredFit == false ){ 
            $('.edit_data_module .bottom-button-set a.edit_size_button').addClass('btn-disable-edit');
          }else{ 
            $('.edit_data_module .bottom-button-set a.edit_size_button').removeClass('btn-disable-edit');
          }
       }else{
                   // Start - Edit change for size module 
            console.log("remove_st_size___",);
          
              var st_semiSize = editLineBSC[0]['_Size?'];    
              var st_semiSilhouette = editLineBSC[0]['_Silhouette?'];
              var st_fit = editLineBSC[0]['_Preferred Fit?'];
        
         
              var semiSizeData = $('.edit_size_module [name="properties[_Size?]"].activeradio').val();
              var semiSilhouetteData;
             if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                 semiSilhouetteData = 'NA';
              }else{
                semiSilhouetteData = $('.edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
              }
              if(typeof semiSilhouetteData == 'undefined'){
                semiSilhouetteData = "NA";
              }
              if(editLineBSC.length > 0 && editLineBSC[0]['category'] == 'jackets'){
                var activePreferredFit = $('.edit_size_module .ProductSize__PreferredFit [type="radio"]').hasClass('activeradio');
                var localSizeArray = {'size':st_semiSize,'st_fit':st_fit};
                var currSizeArray = {'size':semiSizeData,'st_fit':preferredFit};
              }else{
                if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                  var activesemiSilhouette = true
                }else{
                  var activesemiSilhouette = $('.edit_size_module .ProductSize__Silhouette [type="radio"]').hasClass('activeradio');
                  
                }
                var localSizeArray = {'size':st_semiSize,'silhouette':st_semiSilhouette};
                var currSizeArray = {'size':semiSizeData,'silhouette':semiSilhouetteData};
              }
              console.log(localSizeArray)
              console.log(currSizeArray);

              var activeSize = $('.edit_size_module .ProductSize__ShirtSize [type="radio"]').hasClass('activeradio');
              var activeSilhouette = $('.edit_size_module .ProductSize__Silhouette [type="radio"]').hasClass('activeradio');

              if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__ShirtSize')){
               var size_Value = $(this).val();
               let sizeTable = {'XS':36,'S':38,'M':40,'L':42,'XL':44,'2XL':46,'3XL':48,'4XL':50,'5xl':52,'6xl':54,'7xl':56};
                console.log("size_Value__",sizeTable[size_Value]);
               if(sizeTable[size_Value] >= 40){
                  $('.edit_size_module .ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Standard"]').prop('checked',true).addClass('activeradio');
                   $('.edit_size_module .ProductSize__Elements.ProductSize__PreferredFit').addClass('active');
                }
              } 

              
              if(JSON.stringify(localSizeArray) === JSON.stringify(currSizeArray) || activeSize == false || activePreferredFit == false || activesemiSilhouette == false ){
                $('.edit_data_module .bottom-button-set a').addClass('btn-disable-edit');
              }else{
                $('.edit_data_module .bottom-button-set a').removeClass('btn-disable-edit');
              }
           // End - Edit change for size module 
       }
      }
    }else{
    var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
      return (n.categoryName == pdpTypeLow);
    });
        if(profileData.length && profileData[0].category == 'Shirts'){
          var shirtSizeLgData = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
          var ShoulderTypeLgData = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
          var preferredFitLData = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
           
         var shirtSize1 = profileData[0].fitsmart.stdSize.value;
         var ShoulderType1 = profileData[0].fitsmart.shoulderType.value;
         var preferredFit1 = profileData[0].fitsmart.fit.value;

          var sizeArray = {'st_size':shirtSize1,'st_shType':ShoulderType1,'st_fit':preferredFit1};
          var currArray = {'st_size':shirtSizeLgData,'st_shType':ShoulderTypeLgData,'st_fit':preferredFitLData};

          var activeSize = $('.edit_size_module .ProductSize__ShirtSize [type="radio"]').hasClass('activeradio');
          var activeShoulderType = $('.edit_size_module .ProductSize__ShoulderType [type="radio"]').hasClass('activeradio');
          var activePreferredFit = $('.edit_size_module .ProductSize__PreferredFit [type="radio"]').hasClass('activeradio');
          
          if(JSON.stringify(sizeArray) === JSON.stringify(currArray) || activeSize == false || activeShoulderType == false || activePreferredFit == false ){ 
            $('.edit_data_module .bottom-button-set a.edit_size_button').addClass('btn-disable-edit');
          }else{ 
            $('.edit_data_module .bottom-button-set a.edit_size_button').removeClass('btn-disable-edit');
          }
        }else{
              // Start - Edit change for size module 
              var st_semiSize = profileData[0].fitsmart.stdSize.value; 
              var st_semiFit = profileData[0].fit;    

              if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                var st_semiSilhouette = "NA";
                var semiSize = $('.edit_size_module [name="properties[_Size?]"].activeradio').val().toLowerCase();
              } else {
                var st_semiSilhouette = profileData[0]['silhouette']; 
                var semiSize = $('.edit_size_module [name="properties[_Size?]"].activeradio').val();
              }
              var semiFit = $('.edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
          
              if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants'){
                var semisilhouette = "NA";
              } else {
                var semisilhouette = $('.edit_size_module [name="properties[_Silhouette?]"].activeradio').val(); 
              }
              if(pdpType_low == 'jackets'){
                var semiSizeArray = {'size':st_semiSize,'st_fit':st_semiFit};
                var currSizeArray = {'size':semiSize,'st_fit':semiFit};
              }else{
                var semiSizeArray = {'size':st_semiSize,'silhouette':st_semiSilhouette};
                var currSizeArray = {'size':semiSize,'silhouette':semisilhouette};
              }
              console.log('semiSizeArray',semiSizeArray)
              console.log('currSizeArray',currSizeArray)
              
              var activeSize = $('.edit_size_module .ProductSize__ShirtSize [type="radio"]').hasClass('activeradio');
              
             if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants' || pdpType_low == 'jackets'){
                var activeSilhouette = true;
              } else {
                var activeSilhouette = $('.edit_size_module .ProductSize__Silhouette [type="radio"]').hasClass('activeradio');
              }
              if(pdpType_low == 'jackets'){
                var activefit = $('.edit_size_module .ProductSize__PreferredFit [type="radio"]').hasClass('activeradio');
              }else{
               var activefit = true;
              }
              
              if(JSON.stringify(semiSizeArray) === JSON.stringify(currSizeArray) || activeSize == false || activefit == false || activeSilhouette == false  ){ 
                $('.edit_data_module .bottom-button-set a').addClass('btn-disable-edit');
              }else{
                $('.edit_data_module .bottom-button-set a').removeClass('btn-disable-edit');
              }
           // End - Edit change for size module 
        }
      }
   })  
   // End - Button status change, when element change
  
})

$('.save_edited_change').click(function(){
    $('body').addClass('change_size_pop');

     if($(this).hasClass('edit_profile_button'))
     {
       $('.edit_size').addClass('hide');
       $('.edit_profile').removeClass('hide');
       
       $('.confirm_edit_text').text('You have made following changes in the Profile.');
       
     }else if($(this).hasClass('edit_size_button'))
     {
       $('.edit_profile').addClass('hide');
       $('.edit_size').removeClass('hide');
       
       var productType = $('body').attr('data-type');
       $('.confirm_edit_text').text('You have made following changes to '+productType+' sizing.');
       
     }
       
     if($('.notlogged').length > 0){

      // Start - Get localstorage data
        fitsmartObject1 = localStorage.getItem("fitsmartobjNew");
        fitsmartObject1 = JSON.parse(fitsmartObject1);
        var editCategory  = $('body').attr('data-type');

       var editLineBSC;
       // Start - If one brand has fitsmart and other has not
       if(fitsmartObject1.length == 1){
            var st_bType = fitsmartObject1[0]['_Body Type?'];
            var st_height = fitsmartObject1[0]['_Height?'];
            var st_hip = fitsmartObject1[0]['_Hip?'];
           editLineBSC = fitsmartObject1;
       }else {
          editLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
           return (n.category == editCategory);
          });
          console.log('save changes editLineBSC ',editLineBSC)
          if(editLineBSC.length){
            var st_bType = editLineBSC[0]['_Body Type?'];
            var st_height = editLineBSC[0]['_Height?'];
            var st_hip = editLineBSC[0]['_Hip?'];
          } else {
            var st_bType = fitsmartObject1[0]['_Body Type?'];
            var st_height = fitsmartObject1[0]['_Height?'];
            var st_hip = fitsmartObject1[0]['_Hip?'];
          }
       } 
       // End - If one brand has fitsmart and other has not
      // End - Get localstorage data
      // Start - Replace HTML of profile data

        let newBodyType_val = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        let newHeight_val = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
        let newHip_val = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();
       
       if(st_bType != newBodyType_val){
          $('.edit_conform .edit_profile .ProductSize__BodyType').removeClass('hide');
          let newBodyTypeHtml = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').siblings('label').html();
          $('.new_bodyType label').html(newBodyTypeHtml);
  
          let ls_BodyTypeHtml = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"][value="'+st_bType+'"]').siblings('label').html();
          $('.old_bodyType label').html(ls_BodyTypeHtml);
       }else{
         $('.edit_conform .edit_profile .ProductSize__BodyType').addClass('hide');
       }
    
       if(st_height != newHeight_val){
          $('.edit_conform .edit_profile .ProductSize__Height').removeClass('hide');
          let newHeightHtml = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').siblings('label').html();
          $('.new_height label').html(newHeightHtml);
  
          let ls_HeightHtml = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"][value="'+st_height+'"]').siblings('label').html();
          $('.old_height label').html(ls_HeightHtml);
       }else{
         $('.edit_conform .edit_profile .ProductSize__Height').addClass('hide');
       }
       
       // if(st_hip != newHip_val){
       //    $('.edit_conform .edit_profile .ProductSize__Hip').removeClass('hide');
       //    let newHipHtml = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').siblings('label').html();
       //    $('.new_hip label').html(newHipHtml);
  
       //    let ls_HipHtml = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"][value="'+st_hip+'"]').siblings('label').html();
       //    $('.old_hip label').html(ls_HipHtml);
       // }else{
       //   $('.edit_conform .edit_profile .ProductSize__Hip').addClass('hide');
       // }
      // End - Replace HTML of profile data

  
      // Start - Replace HTML of size data
      if(editLineBSC.length > 0 && editLineBSC[0]['category'] == 'shirt'){
         // Start- Localstorage data
          var st_size = editLineBSC[0]['_Shirt Size?'];
          var st_shType = editLineBSC[0]['_Shoulder Type?'];
          var st_fit = editLineBSC[0]['_Preferred Fit?'];
         // End - Localstorage data
         
          let newShirtSize_val = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
          let newSholderType_val = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
          let newPreferredFit_val = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
         
             if(st_size != newShirtSize_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShirtSize').removeClass('hide');
               let newShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').siblings('label').html();
               $('.new_shirtSize label').html(newShirtSizeHtml);
               let ls_ShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"][value="'+st_size+'"]').siblings('label').html();
               $('.old_shirtSize label').html(ls_ShirtSizeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShirtSize').addClass('hide');
             }
      
             if(st_shType != newSholderType_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShoulderType').removeClass('hide');
               let newSholderTypeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').siblings('label').html();
               $('.new_shoulderType label').html(newSholderTypeHtml);
               let ls_SholderTypeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"][value="'+st_shType+'"]').siblings('label').html();
               $('.old_shoulderType label').html(ls_SholderTypeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShoulderType').addClass('hide');
             }
      
             if(st_fit != newPreferredFit_val)
             {
              $('.edit_conform .edit_size .ProductSize__PreferredFit').removeClass('hide');
               let newPreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
               $('.new_preferredFit label').html(newPreferredFitHtml);
               let ls_PreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"][value="'+st_fit+'"]').siblings('label').html();
               $('.old_preferredFit label').html(ls_PreferredFitHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__PreferredFit').addClass('hide');
             }
       }else{
           let st_semiSize = editLineBSC[0]['_Size?']; 
           var st_fit = editLineBSC[0]['_Preferred Fit?'];
           let newSize_val = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
           let newPreferredFit_val = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
            if(st_semiSize != newSize_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShirtSize').removeClass('hide');
               let newSemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').siblings('label').html();
               $('.new_size label').html(newSemiSizeHtml);
               let ls_SemiSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"][value="'+st_semiSize+'"]').siblings('label').html();
               $('.old_size label').html(ls_SemiSizeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShirtSize').addClass('hide');
             } 

           let st_semiSil = editLineBSC[0]['_Silhouette?']; 
           let newSil_val = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();

            if(st_semiSil != newSil_val)
             {
               $('.edit_conform .edit_size .ProductSize__Silhouette').removeClass('hide');
               let newSemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').siblings('label').html();
               $('.new_silhouette label').html(newSemiSilHtml);
               let ls_SemiSilHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"][value="'+st_semiSil+'"]').siblings('label').html();
               $('.old_silhouette label').html(ls_SemiSilHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__Silhouette').addClass('hide');
             }
            if(st_fit != newPreferredFit_val)
             {
              $('.edit_conform .edit_size .ProductSize__PreferredFit').removeClass('hide');
               let newPreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
               $('.new_preferredFit label').html(newPreferredFitHtml);
               let ls_PreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"][value="'+st_fit+'"]').siblings('label').html();
               $('.old_preferredFit label').html(ls_PreferredFitHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__PreferredFit').addClass('hide');
             }
       }

      // End - Replace HTML of size data

      }else{
             // Start - Replace HTML of profile data

         var st_bType = profileAPIData.profileFitsmart.bodyShape;
         var st_height = profileAPIData.profileFitsmart.height;
         var st_hip = profileAPIData.profileFitsmart.hipClass;
  
        let newBodyType_val = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').val();
        let newHeight_val = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').val();
        let newHip_val = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').val();

       if(st_bType != newBodyType_val)
       {
          $('.edit_conform .edit_profile .ProductSize__BodyType').removeClass('hide');
          let newBodyTypeHtml = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"].activeradio').siblings('label').html();
          $('.new_bodyType label').html(newBodyTypeHtml);
  
          let ls_BodyTypeHtml = $('.edit_data_module .edit_profile_module [name="properties[_Body Type?]"][value="'+st_bType+'"]').siblings('label').html();
          $('.old_bodyType label').html(ls_BodyTypeHtml);
       }
       else{
         $('.edit_conform .edit_profile .ProductSize__BodyType').addClass('hide');
       }
        
       if(st_height != newHeight_val)
       {
          $('.edit_conform .edit_profile .ProductSize__Height').removeClass('hide');
          let newHeightHtml = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"].activeradio').siblings('label').html();
          $('.new_height label').html(newHeightHtml);
  
          let ls_HeightHtml = $('.edit_data_module .edit_profile_module [name="properties[_Height?]"][value="'+st_height+'"]').siblings('label').html();
          $('.old_height label').html(ls_HeightHtml);
       }else{
         $('.edit_conform .edit_profile .ProductSize__Height').addClass('hide');
       }

        // if(st_hip != newHip_val)
        // {
        //   $('.edit_conform .edit_profile .ProductSize__Hip').removeClass('hide');
        //   let newHipHtml = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"].activeradio').siblings('label').html();
        //   $('.new_hip label').html(newHipHtml);
  
        //   let ls_HipHtml = $('.edit_data_module .edit_profile_module [name="properties[_Hip?]"][value="'+st_hip+'"]').siblings('label').html();
        //   $('.old_hip label').html(ls_HipHtml);
        // }else{
        //  $('.edit_conform .edit_profile .ProductSize__Hip').addClass('hide');
        // }
      // End - Replace HTML of profile data

             // Start - Replace HTML of size data

    var profileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
      return (n.categoryName == pdpTypeLow) ;
    });

       if(profileData.length > 0){
      if(profileData[0].category == 'Shirts'){

          var st_size = profileData[0].fitsmart.stdSize.value;
         var st_shType = profileData[0].fitsmart.shoulderType.value;
         var st_fit = profileData[0].fitsmart.fit.value;
         
          let newShirtSize_val = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').val();
          let newSholderType_val = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').val();
          let newPreferredFit_val = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
         
             if(st_size != newShirtSize_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShirtSize').removeClass('hide');
               let newShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"].activeradio').siblings('label').html();
               $('.new_shirtSize label').html(newShirtSizeHtml);
               let ls_ShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shirt Size?]"][value="'+st_size+'"]').siblings('label').html();
               $('.old_shirtSize label').html(ls_ShirtSizeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShirtSize').addClass('hide');
             }
      
             if(st_shType != newSholderType_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShoulderType').removeClass('hide');
               let newSholderTypeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"].activeradio').siblings('label').html();
               $('.new_shoulderType label').html(newSholderTypeHtml);
               let ls_SholderTypeHtml = $('.edit_data_module .edit_size_module [name="properties[_Shoulder Type?]"][value="'+st_shType+'"]').siblings('label').html();
               $('.old_shoulderType label').html(ls_SholderTypeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShoulderType').addClass('hide');
             }
      
             if(st_fit != newPreferredFit_val)
             {
              $('.edit_conform .edit_size .ProductSize__PreferredFit').removeClass('hide');
               let newPreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
               $('.new_preferredFit label').html(newPreferredFitHtml);
               let ls_PreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"][value="'+st_fit+'"]').siblings('label').html();
               $('.old_preferredFit label').html(ls_PreferredFitHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__PreferredFit').addClass('hide');
             }
       }else{
           let st_semiSize = profileData[0].fitsmart.stdSize.value; 
           let st_semiSilhouette = profileData[0].silhouette; 
           let st_semiPreferredFit = profileData[0].fit; 
        
           let newSize_val = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').val();
           let newSilhouette_val = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').val();
           let newPreferredFit_val = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').val();
        
         
            if(st_semiSize != newSize_val)
             {
               $('.edit_conform .edit_size .ProductSize__ShirtSize').removeClass('hide');
               let newShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"].activeradio').siblings('label').html();
               $('.new_size label').html(newShirtSizeHtml);
               let ls_ShirtSizeHtml = $('.edit_data_module .edit_size_module [name="properties[_Size?]"][value="'+st_semiSize.toUpperCase()+'"]').siblings('label').html();
               $('.old_size label').html(ls_ShirtSizeHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__ShirtSize').addClass('hide');
             }

             if(st_semiSilhouette != newSilhouette_val)
             {
               $('.edit_conform .edit_size .ProductSize__Silhouette').removeClass('hide');
               let newSilhouetteHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"].activeradio').siblings('label').html();
               $('.new_silhouette label').html(newSilhouetteHtml);
               let ls_SilhouetteHtml = $('.edit_data_module .edit_size_module [name="properties[_Silhouette?]"][value="'+st_semiSilhouette+'"]').siblings('label').html();
               $('.old_silhouette label').html(ls_SilhouetteHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__Silhouette').addClass('hide');
             } 
            if(pdpType_low == 'jackets'){
            if(st_semiPreferredFit != newPreferredFit_val)
             {
               $('.edit_conform .edit_size .ProductSize__PreferredFit').removeClass('hide');
               let newPreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"].activeradio').siblings('label').html();
               $('.new_preferredFit label').html(newPreferredFitHtml);
               let ls_PreferredFitHtml = $('.edit_data_module .edit_size_module [name="properties[_Preferred Fit?]"][value="'+st_semiPreferredFit+'"]').siblings('label').html();
               $('.old_preferredFit label').html(ls_PreferredFitHtml);
             }else{
               $('.edit_conform .edit_size .ProductSize__PreferredFit').addClass('hide');
             } 
            }
        
       }
       }
      }
})
$('.confirm_close').click(function(){
  $('body').removeClass('change_size_pop');
})

// $('.template-korra .Filter_As_Modal-mobile .get-size-button').click(function(){
//    //    alert('select click');
//    //    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
//    //      // IOS Device
//    //      alert('ios detect')
//    // } else {
//    //      // NO IOS Device. 
//    //      alert('not ios')        
//    //    }                                                                         
//     $('.ProductForm__SavedSize').addClass('hide');
//     $('.size-options-korra .ProductForm__SizeContent').removeClass('hide-ProductForm-allcontent');
// })

 $('.confirmChangesBtn').click(function(){
    var editVendor  = $('body').attr('data-vendor');
   if(editVendor == "Bombay Shirt Company" ){
    editVendor = 'bsc';
  } else if(editVendor == "Korra"){
    editVendor = 'korra';
  } else if(editVendor == "cityof_"){
    editVendor = 'cityof_';
  }
   if($('.notlogged').length > 0){

     // Start-animation start
         
          setTimeout(function(){
            $('body').addClass('showAnimation');
            $('.scan-success-loader img').show()
          },500);
      // End- animation start
    
    var bodyType = $('.edit-display-size input.activeradio[name="properties[_Body Type?]"]').val();
    var height = $('.edit-display-size input.activeradio[name="properties[_Height?]"]').val();
    var hipClass = $('.edit-display-size input.activeradio[name="properties[_Hip?]"]').val();
    console.log('bodyType==',bodyType)
    console.log('height==',height)
    console.log('hipClass==',hipClass)
    console.log('fitsmartObject1New',fitsmartObject1);

    if($('.template-bsc').length > 0){
        var shirtSize = $('.edit-display-size input.activeradio[name="properties[_Shirt Size?]"]').val();
        var shoulderType = $('.edit-display-size input.activeradio[name="properties[_Shoulder Type?]"]').val();
        var preferredFit = $('.edit-display-size input.activeradio[name="properties[_Preferred Fit?]"]').val();
        // if($('.edit_profile .ProductSize__BodyType').is(':visible')){
        //   fitsmartObject1 = jQuery.grep(fitsmartObject1, function( n, i ) {
        //    return (n.type != 'korra');
        //   });
        //   localStorage.setItem("fitsmartobjNew", JSON.stringify(fitsmartObject1));
        // }
    }else if($('.template-semi-stitched').length > 0){
      if($('.edit_profile .ProductSize__BodyType').is(':visible')){
          fitsmartObject1 = jQuery.grep(fitsmartObject1, function( n, i ) {
           return (n.category != 'shirt' && n.category != 'jackets');
          });
          localStorage.setItem("fitsmartobjNew", JSON.stringify(fitsmartObject1));
        }
        
        var subSize = $('.edit-display-size input.activeradio[name="properties[_Size?]"]').val();
        var preferredFit = $('.edit-display-size input.activeradio[name="properties[_Preferred Fit?]"]').val();
        var silhouetteData;
      if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants' || pdpType_low == 'jackets'){
          silhouetteData = 'NA';
      }else{
          silhouetteData = $('.edit-display-size input.activeradio[name="properties[_Silhouette?]"]').val();
      }
        // if($('.edit_profile .ProductSize__BodyType').is(':visible')){
        //   fitsmartObject1 = jQuery.grep(fitsmartObject1, function( n, i ) {
        //    return (n.type != 'bsc');
        //   });
        //   localStorage.setItem("fitsmartobjNew", JSON.stringify(fitsmartObject1));
        // }
    }
    if(fitsmartObject1.length){
      $('.Im-New-Filter .ProductSize__BodyType').hide();
      $('.Im-New-Filter .ProductSize__Height').hide();
      // $('.Im-New-Filter .ProductSize__Hip').hide();
    }

     setLocalStoreData(bodyType,hipClass,height,shirtSize,shoulderType,preferredFit,subSize,silhouetteData,pdpType_low)
     $('.save_edited_change').removeClass('edit_size_button');
     $('.save_edited_change').removeClass('edit_profile_button');
  

   }else{
       async function asyncCall() {
          $('body').addClass('showAnimation');
          $('.scan-success-loader img').show()
         //  var animationOnlyScan = document.getElementById("animation_only_Scan");
         // console.log('animationOnlyScan',animationOnlyScan);
         //  animationOnlyScan.play();
        }
     if($('.confirmChangesBtn').hasClass('edit_profile_confirm')){
        var bodyTypeConf = $('.edit_profile_module input.activeradio[name="properties[_Body Type?]"]').val();
        var hipConf = $('.edit_profile_module input.activeradio[name="properties[_Hip?]"]').val();
        var heightConf = $('.edit_profile_module input.activeradio[name="properties[_Height?]"]').val();
        
        var profileArr = [];
        // for solving problem ==> IND to USA login with same email ID
        if(pdpType_low == 'shirt'){
          var shirtSizelg = $('.edit_size_module input.activeradio[name="properties[_Shirt Size?]"]').val();
          var shoulderTypelg = $('.edit_size_module input.activeradio[name="properties[_Shoulder Type?]"]').val();
          var preferredFitlg = $('.edit_size_module input.activeradio[name="properties[_Preferred Fit?]"]').val();
  
          if(typeof shirtSizelg === "undefined"){
            var shirtSizelg = profileData['0']['fitsmart']['stdSize']['value']; 
          }
          
          if(typeof shoulderTypelg === "undefined" && typeof preferredFitlg === "undefined"){
            var shoulderTypelg = profileData['0']['fitsmart']['shoulderType']['value'];
            var preferredFitlg = profileData['0']['fitsmart']['fit']['value'];  
          }
          
          var profileData = {
              // "shopifyId": fitsmartCustomerId,
              "gender": "Male",
              "brand": "NA",
              "category": "NA",
              // "note": "Customer Info stored in notes",
              // "fitSmartVersion": "3",
              // "measurements": [],
              "fitSmart": {
                  "bodyShape": bodyTypeConf,
                  "height": heightConf,
                  "stdSize": shirtSizelg,
                  "fit": preferredFitlg,
                  "shoulderType": shoulderTypelg,
              }
          }
        }else{
          var profileData = {
              // "shopifyId": fitsmartCustomerId,
              "gender": "Male",
              "brand": "NA",
              "category": "NA",
              // "note": "Customer Info stored in notes",
              // "fitSmartVersion": "3",
              // "measurements": [],
              "fitSmart": {
                  "bodyShape": bodyTypeConf,
                  "height": heightConf
              }
          }
        }

        // profileData['customerDetails'] = {};
        // profileData['customerDetails']['customerId'] = fitsmartCustomerId;
        // profileData['customerDetails']['firstName'] = firstName;
        // profileData['customerDetails']['lastName'] = lastName;
        // profileData['customerDetails']['email'] = email;
        // if (phone) {
        //     profileData['customerDetails']['phone'] = phone;
        // }
       console.log('profileData',profileData);
       
        profileArr.push(profileData);
         asyncCall();
         setTimeout(() => {
           createMeasurement1(profileArr);
         }, 500);
    
     }else if($('.confirmChangesBtn').hasClass('edit_size_confirm')){
       console.log('neweditsizedata')

      if(pdpType_low == 'shirt'){

        var bodyTypeConf = $('.edit_profile_module input.activeradio[name="properties[_Body Type?]"]').val();
        var hipConf = $('.edit_profile_module input.activeradio[name="properties[_Hip?]"]').val();
        var heightConf = $('.edit_profile_module input.activeradio[name="properties[_Height?]"]').val();
        
        var shirtSizelg = $('.edit_size_module input.activeradio[name="properties[_Shirt Size?]"]').val();
        var shoulderTypelg = $('.edit_size_module input.activeradio[name="properties[_Shoulder Type?]"]').val();
        var preferredFitlg = $('.edit_size_module input.activeradio[name="properties[_Preferred Fit?]"]').val();
        var hipClass = $('.edit_size_module input.activeradio[name="properties[_Hip?]"]').val();

        if(typeof shirtSizelg === "undefined"){
          var shirtSizelg = profileData['0']['fitsmart']['stdSize']['value']; 
        }
        
        if(typeof shoulderTypelg === "undefined" && typeof preferredFitlg === "undefined"){
          var shoulderTypelg = profileData['0']['fitsmart']['shoulderType']['value'];
          var preferredFitlg = profileData['0']['fitsmart']['fit']['value'];  
        }
        var bscArr = [];
        var bscData = {
            // "shopifyId": fitsmartCustomerId,
            "gender": "Male",
            "category": "Shirts",
            // "note": "Customer Info stored in notes3",
            // "fitSmartVersion": "3",
            // "measurements": [],
            // "isGuest": false,
            "brand": "BOM",
            "fitSmart": {
                "bodyShape": bodyTypeConf,
                "height": heightConf,
                "stdSize": shirtSizelg,
                "fit": preferredFitlg,
                "shoulderType": shoulderTypelg
            }
        }
        // bscData['customerDetails'] = {};
        // bscData['customerDetails']['customerId'] = fitsmartCustomerId;
        // bscData['customerDetails']['firstName'] = firstName;
        // bscData['customerDetails']['lastName'] = lastName;
        // bscData['customerDetails']['email'] = email;
        // if (phone) {
        //     bscData['customerDetails']['phone'] = phone;
        // }
        bscArr.push(bscData);
         asyncCall();
         setTimeout(() => {
           createMeasurement1(bscArr);
         }, 500);
      }else{
            
        var SizeConf = $('.edit_size_module input.activeradio[name="properties[_Size?]"]').val();  
        var preferredFitCon = $('.edit_size_module input.activeradio[name="properties[_Preferred Fit?]"]').val();
        var silhouetteConf;
         if(typeof SizeConf === "undefined"){
           var SizeConf = profileData['0']['fitsmart']['stdSize']['value']; 
         }
        if(pdpType_low == 'jackets'){
         if(typeof preferredFitCon === "undefined"){
           var preferredFitCon = profileData['0']['fit']; 
         }
        }
        if(pdpType_low == 't-shirts' || pdpType_low == 'knitpants' || pdpType_low == 'jackets'){
             silhouetteConf = "NA";
        } else {
            silhouetteConf = $('.edit_size_module input.activeradio[name="properties[_Silhouette?]"]').val();
           if(typeof silhouetteConf === "undefined" ){
              silhouetteConf = profileData['0']['fitsmart']['silhouette']['value'];
           }
        }
        var pdpCat;
        if(pdpType_low == 'jeans'){
          pdpCat = "Jeans";
        } else if(pdpType_low == 'dress pants'){
          pdpCat = "DRESS_PANTS";
        } else if(pdpType_low == 'neapolitan dress pants'){
          pdpCat = "NEAPOLITAN_DRESS_PANTS";
        } else if(pdpType_low == 'chinos'){
          pdpCat = "Chinos";
        } else if(pdpType_low == 't-shirts'){
          pdpCat = "TShirts";
        } else if(pdpType_low == 'jackets'){
          pdpCat = "Jackets";
        } else if(pdpType_low == 'knitpants'){
          pdpCat = "Knitpants";
        } else if(pdpType_low == 'linen pants'){
          pdpCat = "LINEN_PANTS";
        }

          var semiArr = [];
          if(pdpType_low == 'jackets'){
          var semiData = {
              // "shopifyId": fitsmartCustomerId,
              "gender": "Male",
              "category": pdpCat,
              // "note": null,
              // "fitSmartVersion": "Guest",
              // "isGuest": false,
              "brand": "BOM",
              "fit": preferredFitCon,
              "fitSmart": {
                  "stdSize": SizeConf.toLowerCase(),
              }
          }
          }else{
          var semiData = {
              // "shopifyId": fitsmartCustomerId,
              "gender": "Male",
              "category": pdpCat,
              // "note": null,
              // "fitSmartVersion": "Guest",
              // "isGuest": false,
              "brand": "BOM",
              "fit": "NA",
              "fitSmart": {
                  "stdSize": SizeConf.toLowerCase(),
              },
              "silhouette": silhouetteConf,
          }
          }
          // semiData['customerDetails'] = {};
          // semiData['customerDetails']['customerId'] = fitsmartCustomerId;
          // semiData['customerDetails']['firstName'] = firstName;
          // semiData['customerDetails']['lastName'] = lastName;
          // semiData['customerDetails']['email'] = email;
          // if (phone) {
          //     semiData['customerDetails']['phone'] = phone;
          // }
          semiArr.push(semiData);
            asyncCall();
            setTimeout(() => {
              createMeasurement1(semiArr);
            }, 500);
      }
     }

   }
     $('body').removeClass('edit_size_drawer').removeClass('change_size_pop');
     document.querySelector('.close_sizemodule_drawer').click();
   
     var sizeValueCf = $('.edit-display-size .edit_size_module input.activeradio[name="properties[_Size?]"]').val(); 
     console.log('sizeValueCf',sizeValueCf);
      if(sizeValueCf){
         $('.ProductForm__Variants .SizeSwatchList li [type="radio"][value="'+sizeValueCf+'"]').click();
         $('input[type="hidden"][name="properties[_Size?]"]').val(sizeValueCf);
      }

    if(!$('data_drawer_one').hasClass('hide')){ console.log('confirm click')
         $('.contBtnDrawer').hide();
         $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
     }
   
})


    function bodyTypeClick(){
      $(".BodyType__Guide.Link____Guide" ).on( "click", function() {
        $('.ProductForm-Filter .ProductForm__Size').addClass('hide');
        $('#BodyType__Guide').removeClass('mfp-hide');
        $('body').removeClass('edit_size_drawer');
        
       // Start - Mobile
        if (window.innerWidth <= 768) {
          $('.BodyType__GuidePopup .content-wrapper').not('.slick-initialized').slick({
              dots: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              autoplaySpeed: 2000,
              arrows: true
          }).on("afterChange", function(ev, slick, current, next) {
            $(".BodyType__GuidePopup .content-tab-title .heading").removeClass('active');
            $('.BodyType__GuidePopup .content-tab-title .heading[data-count="'+current+'"]').addClass('active');
          });
          
          $('.BodyType__GuidePopup .content-tab-title .heading').click(function(e) {
              e.preventDefault();
              $(this).closest('.BodyType__GuidePopup').find(".content-tab-title .heading").removeClass('active');
              $(this).addClass('active');
              var slideno = $(this).data('count');
              $(this).closest('.BodyType__GuidePopup').find('.content-wrapper').slick('slickGoTo', slideno);
          });
        }
     // End -Mobile   
      });

       $(".hip__Guide.Link____Guide" ).on( "click", function() {
        $('.ProductForm-Filter .ProductForm__Size').addClass('hide');
        $('#hip__Guide').removeClass('mfp-hide');
        $('body').removeClass('edit_size_drawer');
        
       // Start - Mobile
        if (window.innerWidth <= 768) {
          $('.hip__GuidePopup .content-wrapper').not('.slick-initialized').slick({
              dots: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              autoplaySpeed: 2000,
              arrows: true
          }).on("afterChange", function(ev, slick, current, next) {
            $(".hip__GuidePopup .content-tab-title .heading").removeClass('active');
            $('.hip__GuidePopup .content-tab-title .heading[data-count="'+current+'"]').addClass('active');
          });
          
          $('.hip__GuidePopup .content-tab-title .heading').click(function(e) {
              e.preventDefault();
              $(this).closest('.hip__GuidePopup').find(".content-tab-title .heading").removeClass('active');
              $(this).addClass('active');
              var slideno = $(this).data('count');
              $(this).closest('.hip__GuidePopup').find('.content-wrapper').slick('slickGoTo', slideno);
          });
        }
     // End -Mobile   
      });
      
      $(".ShoulderType__Guide.Link____Guide" ).on( "click", function() {
        $('.ProductForm-Filter .ProductForm__Size').addClass('hide');
        $('#ShoulderType__Guide').removeClass('mfp-hide');
        $('body').removeClass('edit_size_drawer');
        
        // Start - Mobile
        if (window.innerWidth <= 768) {
            $('.ShoulderType__GuidePopup .content-wrapper').not('.slick-initialized').slick({
              dots: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              autoplaySpeed: 2000,
              arrows: true
           }).on("afterChange", function(ev, slick, current, next) {
            $(".ShoulderType__GuidePopup .content-tab-title .heading").removeClass('active');
            $('.ShoulderType__GuidePopup .content-tab-title .heading[data-count="'+current+'"]').addClass('active');
          });
          
          $('.ShoulderType__GuidePopup .content-tab-title .heading').click(function(e) {
            e.preventDefault();
            $(this).closest('.ShoulderType__GuidePopup').find(".content-tab-title .heading").removeClass('active');
            $(this).addClass('active');
            var slideno = $(this).data('count');
            $(this).closest('.ShoulderType__GuidePopup').find('.content-wrapper').slick('slickGoTo', slideno);
          });
        }
        // End -Mobile
      });

      $(".BodyType__GuideDismiss, .hip__GuideDismiss").on( "click", function() {
        $('.ProductForm-Filter .ProductForm__Size').removeClass('hide');
        $('#BodyType__Guide').addClass('mfp-hide');
        if(localStorage.getItem("fitsmartobjNew") != null && $('.notlogged').length > 0){ 
          console.log('not logged')
             $('body').addClass('edit_size_drawer');        
        } else if($('.logged').length > 0){
          console.log(' logged')
          if(typeof fitSmartProfiles != 'undefined'){
            if(fitSmartProfiles.length > 0){
              var profileDataN = jQuery.grep(fitSmartProfiles, function( n, i ) {
              return (n.categoryName == pdpTypeLow) ;
              });
              console.log('profileDataN',profileDataN)
              if(profileDataN.length > 0){
                $('body').addClass('edit_size_drawer');
              }else{
                 $('body').removeClass('edit_size_drawer'); 
              }
                   
            }else{
               $('body').removeClass('edit_size_drawer'); 
            }
          }
        }                                                                            
      });
      $(".ShoulderType__GuideDismiss").on( "click", function() {
        $('.ProductForm-Filter .ProductForm__Size').removeClass('hide');
        $('#ShoulderType__Guide').addClass('mfp-hide');

        if(localStorage.getItem("fitsmartobjNew") != null && $('.notlogged').length > 0){ 
          console.log('not logged')
           $('body').addClass('edit_size_drawer');
            var editVendor  = $('body').attr('data-vendor');
             if(editVendor == "Bombay Shirt Company" ){
              editVendor = 'bsc';
            } else if(editVendor == "Korra"){
              editVendor = 'korra';
            } else if(editVendor == "cityof_"){
              editVendor = 'cityof_';
            }
             var grepLineBSC = jQuery.grep(fitsmartObject1, function( n, i ) {
                return (n.category == pdpTypeLow);
             });
            console.log("fitsmartObject1",fitsmartObject1);
           
            if(grepLineBSC.length > 0){
               console.log('bsc found')
               $('body').addClass('edit_size_drawer'); 
            }else{
               console.log('bsc not found')
               $('body').removeClass('edit_size_drawer');  
            }
          
              
        } else if($('.logged').length > 0){
          console.log(' logged')
          if(typeof fitSmartProfiles != 'undefined'){
            if(fitSmartProfiles.length > 0){
              
                //  var editVendor  = $('body').attr('data-vendor');
                //  if(editVendor == "Bombay Shirt Company" ){
                //   editVendor = 'BOM';
                // } else if(editVendor == "Korra"){
                //     editVendor = 'KOR';
                // } else if(editVendor == "cityof_"){
                //     editVendor = 'COF';
                // }

                 var editcategory  = $('body').attr('data-type');
                  if(editcategory == "shirt" ){
                    editcategory = 'Shirts';
                  } else if(editcategory == "jeans"){
                      editcategory = 'Jeans';
                  } else if(editcategory == "chinos"){
                      editcategory = 'Chinos';
                  }else if(editcategory == "dress pants"){
                      editcategory = 'DRESS_PANTS';
                  }else if(editcategory == "neapolitan dress pants"){
                      editcategory = 'NEAPOLITAN_DRESS_PANTS';
                  }else if(editcategory == "knitpants"){
                      editcategory = 'Knitpants';
                  }else if(editcategory == "linen pants"){
                      editcategory = 'LINEN_PANTS';
                  }
              
                 var grepProfileData = jQuery.grep(fitSmartProfiles, function( n, i ) {
                    return (n.category == editcategory);
                 });
                
                 if(grepProfileData.length > 0){
                   console.log('bsc found')
                   $('body').addClass('edit_size_drawer'); 
                }else{
                   console.log('bsc not found')
                   $('body').removeClass('edit_size_drawer');  
                }
              
            }
            
          }
        }
                                                                                      
      });
      
    }
  
    // Start - For size guide drawer,call when "View" btn
    bodyTypeClick();
    /*
    if(localStorage.getItem("fitsmartobjNew") != null && $('.notlogged').length > 0){
      bodyTypeClick();
    } else if($('.logged').length > 0){
      if(typeof fitSmartProfiles != 'undefined'){
        if(fitSmartProfiles.length > 0){
          bodyTypeClick(); 
        }
      }
    }*/
    // End - For size guide drawer,call when "View" btn 


   $('.declineChangeBtn').click(function(){
      $('body').removeClass('change_size_pop');
   })

   $(document).on("click",".contBtnDrawer",function() {
      document.querySelector('.close_sizemodule_drawer').click();
   })

   $('.korra_size').click(function(){
      //console.log('click');
      $('.contBtnDrawer').hide();
      $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
   })
   $('.customise-new_measure .single-closer').click(function(){
      //console.log('close');
       $('.contBtnDrawer').show();
       $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
   })
  
    $('#Filter_As_Modal .ProductForm__SizeContent li [data-tag="one"]').click(function(){
      if(!$('#Filter_As_Modal .data_drawer_two').hasClass('hide'))
      { console.log('click')
         $('.contBtnDrawer').show();
         $('#Filter_As_Modal .ProductForm__Size').addClass('your-size-second');
      }
      
    })
    
    $('#Filter_As_Modal .ProductForm__SizeContent li [data-tag="two"]').click(function(){
      if(!$('#Filter_As_Modal .data_drawer_two').hasClass('hide'))
      { console.log('click')
        $('.contBtnDrawer').hide();
        $('#Filter_As_Modal .ProductForm__Size').removeClass('your-size-second');
      }
    })
 
$(document).ready(function(){
$('.closemodal_eve').click(function(){
    $.magnificPopup.instance.close();
})
  setTimeout(function() {
     $('.pro-nex-prev').addClass('arrowAniation')
    }, 500);
  
    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    }
    function setCookie(cname,cvalue,exdays){
      var d = new Date();
      d.setTime(d.getTime()+ (exdays*24*60*60*1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function checkCookie() {
      var c_news = getCookie("overlyClose");  
      if (c_news == "over_close") {
        console.log('note over')
      }  
      else{
        console.log('note over12')
        $('body').addClass('show_overlay');
        $('.close_overlay , .next-pro-overlay').on('click',function(){
           $('body').removeClass('show_overlay');
           setCookie('overlyClose','over_close',1);
        });
         
      }
    }

var  boostHandleStore = localStorage.getItem("boostHandle");
    boostHandleStore = JSON.parse(boostHandleStore);
    console.log('boostHandleStore',boostHandleStore)
    if(boostHandleStore && boostHandleStore.length > 0){
      var prod_handle = $('body').data('product-handle');
      var currIndex =  boostHandleStore.indexOf(prod_handle);
      var prevIndex =  currIndex - 1 ;
      var nextIndex =  currIndex + 1 ;
      var prevHandle; 
      var nextHandle;
      if(prevIndex >= 0){
        prevHandle = '/products/'+boostHandleStore[prevIndex];
      }else{
        prevHandle = ""
      }
      if(nextIndex <= boostHandleStore.length - 1 ){
        nextHandle = '/products/'+boostHandleStore[nextIndex];
      }else{
        nextHandle = "";
      }
      $('.customizePDP').attr('data-prevprod',prevHandle);
      $('.customizePDP').attr('data-nextprod',nextHandle);
      $('.pro-nex-prev .pro-prev').attr('href',prevHandle);
      $('.pro-nex-prev .pro-next').attr('href',nextHandle);
   }
if($('.ProductForm').hasClass('bsc')){
  if($('.customise-box').hasClass('hide')){
  $(".Product__Slideshow, .pro-nex-prev").on('swiped', function(e) {
      var swapRigth =  $('.customizePDP').attr('data-prevprod');
      var swapLeft = $('.customizePDP').attr('data-nextprod');
      if(swapRigth){
        if (e.detail.dir == 'right'){
          window.location.href = swapRigth;
          $('body').addClass('movedRight')
        }
      }
      if(swapLeft){
        if (e.detail.dir == 'left'){
          window.location.href = swapLeft;
           $('body').addClass('movedLeft')
        }
      }
 });
}
}else{
  $(".Product__Slideshow, .pro-nex-prev").on('swiped', function(e) {
      var swapRigth =  $('.customizePDP').attr('data-prevprod');
      var swapLeft = $('.customizePDP').attr('data-nextprod');
      if(swapRigth){
        if (e.detail.dir == 'right'){
          window.location.href = swapRigth;
          $('body').addClass('movedRight')
        }
      }
      if(swapLeft){
        if (e.detail.dir == 'left'){
          window.location.href = swapLeft;
           $('body').addClass('movedLeft')
        }
      }
 });
}  
$('body').on('click', '.similar-product', function(event) {
    $('body').addClass('pdp-similar-product');
});
  
$('.close_similarView').click(function(){
   $('body').removeClass('pdp-similar-product');
})

$('body').on('click', '.meta_colors', function(event) {
    $('body').addClass('pdp-metacolor');
});

$('.new-color-varient .varient-title .hide-close').click(function(){
    $('body').removeClass('pdp-metacolor');
})
var prev = $('.customizePDP').attr('data-prevprod');
var next = $('.customizePDP').attr('data-nextprod');
$('.pro-nex-prev').removeClass('hide');
if(prev !== ""){
  $('.pro-prev').removeClass('hide');
}else{
  $('.pro-prev').addClass('hide');
}

if(next !== ""){
  $('.pro-next').removeClass('hide');
}else{
  $('.pro-next').addClass('hide');
}
  
if(prev !== "" || next !== ""){
    if(!$('body').hasClass('temp_webview')){
    checkCookie();
  }
  $(window).scroll(function() {
    if($('.ProductForm').hasClass('bsc')){
      if($('.customise-box').hasClass('hide')){
        var lastImg = $('.main_pgp_image:last-child').offset().top;
        var scroll = $(window).scrollTop();
        var height = $(window).height();
        if(lastImg < scroll){
            $('.pro-nex-prev').addClass('hide'); 
         } else {
             $('.pro-nex-prev').removeClass('hide');
         }
      }else{
        $('.pro-nex-prev').addClass('hide'); 
       }
    }else{
      if($('body').hasClass('open_semicustom')){
        $('.pro-nex-prev').addClass('hide'); 
      }else{
        var lastImg = $('.main_pgp_image:last-child').offset().top;
        var scroll = $(window).scrollTop();
        var height = $(window).height();
        if(lastImg < scroll){
            $('.pro-nex-prev').addClass('hide'); 
         } else {
             $('.pro-nex-prev').removeClass('hide');
        }
      }

    }
  });
}
})
}